{
  "level": "ab01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:ab01",
    "objects": "AREAS.E3:ab01.e3",
    "mesh": "TREES.E3:ab01.e3"
  },
  "spawn_point": {
    "position": [
      -3374.4171283645514,
      -5007.945427610988,
      1060.70703125
    ],
    "facing_rad": 0.0,
    "look_point": [
      -3374.4171283645514,
      -4907.945427610988,
      1060.70703125
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3460.0,
      -5095.00048828125,
      1036.70703125
    ],
    "bbox_max": [
      -2980.000244140625,
      -4925.00048828125,
      1109.29541015625
    ],
    "vertex_count": 649,
    "vertices": [
      [
        -2980.000244140625,
        -5094.0,
        1056.70703125
      ],
      [
        -2980.000244140625,
        -5034.0,
        1056.70703125
      ],
      [
        -2980.000244140625,
        -4976.0,
        1056.70703125
      ],
      [
        -2980.000244140625,
        -5034.0,
        1056.70703125
      ],
      [
        -3357.548828125,
        -5036.416015625,
        1074.4769287109375
      ],
      [
        -3357.548828125,
        -5036.416015625,
        1064.376953125
      ],
      [
        -3357.548828125,
        -5036.416015625,
        1064.376953125
      ],
      [
        -3363.450927734375,
        -5037.048828125,
        1064.3052978515625
      ],
      [
        -3363.450927734375,
        -5037.048828125,
        1064.3052978515625
      ],
      [
        -3363.450927734375,
        -5037.048828125,
        1074.4052734375
      ],
      [
        -3370.0,
        -5095.00048828125,
        1071.70703125
      ],
      [
        -3370.0,
        -5081.00048828125,
        1077.70703125
      ],
      [
        -3358.909423828125,
        -5066.4033203125,
        1061.70703125
      ],
      [
        -3358.909423828125,
        -5066.4033203125,
        1061.70703125
      ],
      [
        -3358.306396484375,
        -5070.2998046875,
        1061.70703125
      ],
      [
        -3370.0,
        -5081.00048828125,
        1061.70703125
      ],
      [
        -3370.0,
        -5095.00048828125,
        1061.70703125
      ],
      [
        -3358.306396484375,
        -5070.2998046875,
        1061.70703125
      ],
      [
        -3358.306396484375,
        -5070.2998046875,
        1071.8070068359375
      ],
      [
        -3362.0,
        -5073.95654296875,
        1061.70703125
      ],
      [
        -3362.0,
        -5073.95654296875,
        1071.8070068359375
      ],
      [
        -3362.0,
        -5065.79736328125,
        1071.8070068359375
      ],
      [
        -3362.0,
        -5065.79736328125,
        1061.70703125
      ],
      [
        -3362.0,
        -5065.79736328125,
        1071.8070068359375
      ],
      [
        -3362.0,
        -5067.8359375,
        1071.8070068359375
      ],
      [
        -3358.909423828125,
        -5066.4033203125,
        1071.8070068359375
      ],
      [
        -3362.0,
        -5073.95654296875,
        1071.8070068359375
      ],
      [
        -3362.0,
        -5073.8564453125,
        1071.8070068359375
      ],
      [
        -3358.306396484375,
        -5070.2998046875,
        1071.8070068359375
      ],
      [
        -3358.909423828125,
        -5066.4033203125,
        1071.8070068359375
      ],
      [
        -3362.0,
        -5073.8564453125,
        1071.8070068359375
      ],
      [
        -3370.0,
        -5095.00048828125,
        1061.70703125
      ],
      [
        -3370.0,
        -5095.00048828125,
        1071.70703125
      ],
      [
        -3370.0,
        -5081.00048828125,
        1064.70703125
      ],
      [
        -3362.0,
        -5081.00048828125,
        1064.70703125
      ],
      [
        -3367.00048828125,
        -5083.50048828125,
        1064.70703125
      ],
      [
        -3363.450927734375,
        -5037.048828125,
        1074.4052734375
      ],
      [
        -3357.548828125,
        -5036.416015625,
        1074.4769287109375
      ],
      [
        -3356.056884765625,
        -5068.05029296875,
        1070.895751953125
      ],
      [
        -3356.056884765625,
        -5068.05029296875,
        1070.895751953125
      ],
      [
        -3358.306396484375,
        -5070.2998046875,
        1070.6409912109375
      ],
      [
        -3257.0,
        -5025.64306640625,
        1075.0
      ],
      [
        -3247.0,
        -5024.57177734375,
        1075.0
      ],
      [
        -3257.0,
        -5025.64306640625,
        1075.0
      ],
      [
        -3295.0,
        -5029.71484375,
        1075.0
      ],
      [
        -3295.0,
        -5029.71484375,
        1075.0
      ],
      [
        -3295.0,
        -5029.71484375,
        1080.6070556640625
      ],
      [
        -3247.0,
        -5024.57177734375,
        1064.699951171875
      ],
      [
        -3257.0,
        -5025.64306640625,
        1064.699951171875
      ],
      [
        -3257.0,
        -5025.64306640625,
        1064.699951171875
      ],
      [
        -3295.0,
        -5029.71484375,
        1064.699951171875
      ],
      [
        -3295.0,
        -5029.71484375,
        1065.8070068359375
      ],
      [
        -3318.0,
        -5032.1787109375,
        1065.8070068359375
      ],
      [
        -3247.0,
        -5035.00048828125,
        1065.8070068359375
      ],
      [
        -3247.0,
        -5024.57177734375,
        1064.699951171875
      ],
      [
        -3247.0,
        -5024.57177734375,
        1065.8070068359375
      ],
      [
        -3247.0,
        -5024.57177734375,
        1075.0
      ],
      [
        -3357.990234375,
        -5033.56298828125,
        1064.699951171875
      ],
      [
        -3363.990234375,
        -5033.56298828125,
        1064.699951171875
      ],
      [
        -3363.990234375,
        -5033.56298828125,
        1064.699951171875
      ],
      [
        -3363.450927734375,
        -5037.048828125,
        1064.699951171875
      ],
      [
        -3357.548828125,
        -5036.416015625,
        1064.699951171875
      ],
      [
        -3357.990234375,
        -5033.56298828125,
        1064.699951171875
      ],
      [
        -3325.78955078125,
        -5002.44287109375,
        1084.70703125
      ],
      [
        -3346.739990234375,
        -5002.193359375,
        1084.70703125
      ],
      [
        -3260.0546875,
        -5003.2255859375,
        1078.5999755859375
      ],
      [
        -3260.0546875,
        -5003.2255859375,
        1077.70703125
      ],
      [
        -3263.53955078125,
        -4985.70556640625,
        1077.70703125
      ],
      [
        -3301.348876953125,
        -4991.064453125,
        1077.70703125
      ],
      [
        -3296.981689453125,
        -4993.982421875,
        1077.70703125
      ],
      [
        -3306.5,
        -4990.03955078125,
        1077.70703125
      ],
      [
        -3301.348876953125,
        -4991.064453125,
        1077.70703125
      ],
      [
        -3296.981689453125,
        -4993.982421875,
        1077.70703125
      ],
      [
        -3294.063720703125,
        -4998.34912109375,
        1077.70703125
      ],
      [
        -3293.13818359375,
        -5002.83154296875,
        1078.6070556640625
      ],
      [
        -3294.874755859375,
        -5002.81103515625,
        1080.33935546875
      ],
      [
        -3294.063720703125,
        -4998.34912109375,
        1077.70703125
      ],
      [
        -3293.13818359375,
        -5002.83154296875,
        1078.6070556640625
      ],
      [
        -3293.13818359375,
        -5002.83154296875,
        1077.70703125
      ],
      [
        -3307.5,
        -4990.23828125,
        1078.6070556640625
      ],
      [
        -3306.5,
        -4990.03955078125,
        1077.70703125
      ],
      [
        -3307.5,
        -4990.23828125,
        1077.70703125
      ],
      [
        -3346.739990234375,
        -5002.193359375,
        1084.70703125
      ],
      [
        -3352.196044921875,
        -5002.12841796875,
        1079.150390625
      ],
      [
        -3352.196044921875,
        -5002.12841796875,
        1079.150390625
      ],
      [
        -3352.72607421875,
        -5002.1220703125,
        1078.6099853515625
      ],
      [
        -3352.72607421875,
        -5002.1220703125,
        1078.6099853515625
      ],
      [
        -3349.46044921875,
        -4985.70556640625,
        1077.70703125
      ],
      [
        -3352.72607421875,
        -5002.1220703125,
        1077.70703125
      ],
      [
        -3323.79443359375,
        -5002.466796875,
        1077.70703125
      ],
      [
        -3325.78955078125,
        -5002.44287109375,
        1084.70703125
      ],
      [
        -3311.651123046875,
        -4991.064453125,
        1077.70703125
      ],
      [
        -3260.0546875,
        -5003.2255859375,
        1064.699951171875
      ],
      [
        -3352.72607421875,
        -5002.1220703125,
        1064.699951171875
      ],
      [
        -3319.79638671875,
        -5002.5146484375,
        1065.800048828125
      ],
      [
        -3293.13818359375,
        -5002.83154296875,
        1065.800048828125
      ],
      [
        -3307.5,
        -4987.19921875,
        1065.800048828125
      ],
      [
        -3307.5,
        -4977.00048828125,
        1065.800048828125
      ],
      [
        -3321.744140625,
        -4997.18603515625,
        1065.800048828125
      ],
      [
        -3318.167236328125,
        -4991.8330078125,
        1065.800048828125
      ],
      [
        -3318.167236328125,
        -4991.8330078125,
        1065.800048828125
      ],
      [
        -3312.814208984375,
        -4988.25634765625,
        1065.800048828125
      ],
      [
        -3322.796630859375,
        -5002.478515625,
        1064.699951171875
      ],
      [
        -3321.744140625,
        -4997.18603515625,
        1065.800048828125
      ],
      [
        -3322.796630859375,
        -5002.478515625,
        1065.800048828125
      ],
      [
        -3291.12841796875,
        -5002.85546875,
        1075.70703125
      ],
      [
        -3291.12841796875,
        -5002.85546875,
        1069.70703125
      ],
      [
        -3307.5,
        -4987.8017578125,
        1077.70703125
      ],
      [
        -3307.5,
        -4987.8017578125,
        1069.3095703125
      ],
      [
        -3291.12841796875,
        -5002.85546875,
        1069.70703125
      ],
      [
        -3293.13818359375,
        -5002.83154296875,
        1069.70703125
      ],
      [
        -3307.5,
        -4987.8017578125,
        1069.70703125
      ],
      [
        -3322.796630859375,
        -5002.478515625,
        1068.70703125
      ],
      [
        -3293.13818359375,
        -5002.83154296875,
        1069.70703125
      ],
      [
        -3293.13818359375,
        -5002.83154296875,
        1065.800048828125
      ],
      [
        -3321.958984375,
        -5002.48876953125,
        1069.5467529296875
      ],
      [
        -3321.799072265625,
        -5002.49072265625,
        1069.70703125
      ],
      [
        -3322.796630859375,
        -5002.478515625,
        1068.70703125
      ],
      [
        -3321.958984375,
        -5002.48876953125,
        1069.5467529296875
      ],
      [
        -3291.12841796875,
        -5002.85546875,
        1075.70703125
      ],
      [
        -3293.13818359375,
        -5002.83154296875,
        1075.70703125
      ],
      [
        -3321.72265625,
        -4995.38916015625,
        1077.70703125
      ],
      [
        -3321.799072265625,
        -5002.49072265625,
        1075.70703125
      ],
      [
        -3323.79443359375,
        -5002.466796875,
        1077.70703125
      ],
      [
        -3293.13818359375,
        -5002.83154296875,
        1075.70703125
      ],
      [
        -3321.799072265625,
        -5002.49072265625,
        1069.70703125
      ],
      [
        -3321.799072265625,
        -5002.49072265625,
        1075.70703125
      ],
      [
        -3295.0,
        -5023.50048828125,
        1075.0
      ],
      [
        -3295.0,
        -5024.50048828125,
        1075.0
      ],
      [
        -3364.0,
        -5023.50048828125,
        1065.8070068359375
      ],
      [
        -3364.0,
        -5033.50048828125,
        1065.8070068359375
      ],
      [
        -3358.0,
        -5023.50048828125,
        1065.8070068359375
      ],
      [
        -3358.0,
        -5033.50048828125,
        1065.8070068359375
      ],
      [
        -3358.0,
        -5033.50048828125,
        1065.8070068359375
      ],
      [
        -3357.548828125,
        -5036.416015625,
        1065.8070068359375
      ],
      [
        -3247.0,
        -5023.5,
        1065.8070068359375
      ],
      [
        -3247.0,
        -5024.50048828125,
        1065.8070068359375
      ],
      [
        -3247.0,
        -5024.50048828125,
        1065.8070068359375
      ],
      [
        -3247.0,
        -5024.57177734375,
        1065.8070068359375
      ],
      [
        -3358.0,
        -5033.56298828125,
        1064.699951171875
      ],
      [
        -3363.450927734375,
        -5037.048828125,
        1064.70703125
      ],
      [
        -3364.0,
        -5033.50048828125,
        1065.8070068359375
      ],
      [
        -3363.450927734375,
        -5037.048828125,
        1065.8070068359375
      ],
      [
        -3358.0,
        -5036.46435546875,
        1074.471435546875
      ],
      [
        -3353.000244140625,
        -5003.5009765625,
        1065.800048828125
      ],
      [
        -3370.0,
        -5003.50048828125,
        1065.800048828125
      ],
      [
        -3237.0,
        -5003.5,
        1065.800048828125
      ],
      [
        -3260.0,
        -5003.5,
        1065.800048828125
      ],
      [
        -3323.0,
        -5003.50048828125,
        1065.800048828125
      ],
      [
        -3322.796630859375,
        -5002.478515625,
        1065.800048828125
      ],
      [
        -3260.0,
        -5003.5,
        1065.800048828125
      ],
      [
        -3260.0546875,
        -5003.2255859375,
        1065.800048828125
      ],
      [
        -3352.72607421875,
        -5002.1220703125,
        1065.800048828125
      ],
      [
        -3353.000244140625,
        -5003.5009765625,
        1065.800048828125
      ],
      [
        -3323.0,
        -5003.50048828125,
        1065.800048828125
      ],
      [
        -3323.0,
        -5023.50048828125,
        1065.800048828125
      ],
      [
        -3324.255126953125,
        -5003.50048828125,
        1078.5999755859375
      ],
      [
        -3324.255126953125,
        -5023.50048828125,
        1078.5999755859375
      ],
      [
        -3293.0,
        -5003.50048828125,
        1078.5999755859375
      ],
      [
        -3293.0,
        -5023.50048828125,
        1078.5999755859375
      ],
      [
        -2980.000244140625,
        -5094.0,
        1041.70703125
      ],
      [
        -2980.000244140625,
        -5094.0,
        1036.70703125
      ],
      [
        -2980.000244140625,
        -5034.0,
        1036.70703125
      ],
      [
        -2980.000244140625,
        -5034.0,
        1041.70703125
      ],
      [
        -2980.000244140625,
        -4976.0,
        1036.70703125
      ],
      [
        -2980.000244140625,
        -4976.0,
        1041.70703125
      ],
      [
        -2980.000244140625,
        -5034.0,
        1041.70703125
      ],
      [
        -2980.000244140625,
        -5034.0,
        1036.70703125
      ],
      [
        -3430.0,
        -5016.20068359375,
        1096.70703125
      ],
      [
        -3430.0,
        -4971.00048828125,
        1096.70703125
      ],
      [
        -3430.0,
        -5018.20068359375,
        1085.572998046875
      ],
      [
        -3430.0,
        -5018.20068359375,
        1092.6864013671875
      ],
      [
        -3430.0,
        -4968.900390625,
        1092.53173828125
      ],
      [
        -3430.0,
        -4968.900390625,
        1085.7276611328125
      ],
      [
        -3430.0,
        -4971.00048828125,
        1096.70703125
      ],
      [
        -3430.0,
        -4968.900390625,
        1092.53173828125
      ],
      [
        -3430.0,
        -4968.900390625,
        1085.7276611328125
      ],
      [
        -3430.0,
        -5018.20068359375,
        1092.6864013671875
      ],
      [
        -3430.0,
        -5016.20068359375,
        1096.70703125
      ],
      [
        -3430.0,
        -5018.20068359375,
        1085.572998046875
      ],
      [
        -3459.5,
        -4987.50048828125,
        1085.20703125
      ],
      [
        -3459.5,
        -4987.50048828125,
        1085.873779296875
      ],
      [
        -3460.0,
        -4987.50048828125,
        1085.873779296875
      ],
      [
        -3460.0,
        -4987.50048828125,
        1085.20703125
      ],
      [
        -3459.5,
        -4988.00048828125,
        1085.20703125
      ],
      [
        -3459.5,
        -4988.00048828125,
        1085.70703125
      ],
      [
        -3459.5,
        -4987.50048828125,
        1085.873779296875
      ],
      [
        -3459.5,
        -4987.50048828125,
        1085.20703125
      ],
      [
        -3435.5,
        -4985.00048828125,
        1081.70703125
      ],
      [
        -3451.5,
        -4985.00048828125,
        1081.70703125
      ],
      [
        -3450.5,
        -4985.00048828125,
        1083.7069091796875
      ],
      [
        -3436.5,
        -4985.00048828125,
        1083.7069091796875
      ],
      [
        -3459.5,
        -4988.00048828125,
        1081.70703125
      ],
      [
        -3459.5,
        -4988.00048828125,
        1088.5194091796875
      ],
      [
        -3459.5,
        -4987.50048828125,
        1088.3631591796875
      ],
      [
        -3459.5,
        -4987.50048828125,
        1088.3631591796875
      ],
      [
        -3460.0,
        -4987.50048828125,
        1088.3631591796875
      ],
      [
        -3459.5,
        -4988.00048828125,
        1096.70703125
      ],
      [
        -3435.5,
        -5005.00048828125,
        1081.70703125
      ],
      [
        -3451.5,
        -5005.00048828125,
        1081.70703125
      ],
      [
        -3450.5,
        -5005.00048828125,
        1083.7069091796875
      ],
      [
        -3436.5,
        -5005.00048828125,
        1083.7069091796875
      ],
      [
        -3370.02685546875,
        -5064.00048828125,
        1081.8070068359375
      ],
      [
        -3370.02685546875,
        -5081.00048828125,
        1081.8070068359375
      ],
      [
        -3370.0,
        -5064.00048828125,
        1081.70703125
      ],
      [
        -3370.02685546875,
        -5064.00048828125,
        1081.8070068359375
      ],
      [
        -3370.0,
        -5081.00048828125,
        1081.70703125
      ],
      [
        -3370.02685546875,
        -5081.00048828125,
        1081.8070068359375
      ],
      [
        -3430.0,
        -4968.97900390625,
        1092.687744140625
      ],
      [
        -3418.70458984375,
        -4930.4365234375,
        1079.70703125
      ],
      [
        -3427.029052734375,
        -4940.70068359375,
        1079.70703125
      ],
      [
        -3427.029052734375,
        -4940.70068359375,
        1079.70703125
      ],
      [
        -3430.0,
        -4953.50048828125,
        1079.70703125
      ],
      [
        -3430.0,
        -5059.17236328125,
        1079.70703125
      ],
      [
        -3418.0,
        -5059.17236328125,
        1079.70703125
      ],
      [
        -3418.0,
        -5064.00048828125,
        1081.70703125
      ],
      [
        -3430.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3418.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3418.0,
        -5064.00048828125,
        1081.70703125
      ],
      [
        -3418.0,
        -4930.1181640625,
        1081.70703125
      ],
      [
        -3418.0,
        -4930.1181640625,
        1079.70703125
      ],
      [
        -3418.70458984375,
        -4930.4365234375,
        1079.70703125
      ],
      [
        -3420.0,
        -5056.4853515625,
        1079.70703125
      ],
      [
        -3420.0,
        -5058.00048828125,
        1079.70703125
      ],
      [
        -3420.0,
        -5059.171875,
        1081.70703125
      ],
      [
        -3420.0,
        -5058.00048828125,
        1079.70703125
      ],
      [
        -3420.0,
        -5059.17236328125,
        1079.70703125
      ],
      [
        -3422.0,
        -5058.00048828125,
        1079.70703125
      ],
      [
        -3422.0,
        -5056.4853515625,
        1079.70703125
      ],
      [
        -3422.0,
        -5059.17236328125,
        1079.70703125
      ],
      [
        -3422.0,
        -5058.00048828125,
        1079.70703125
      ],
      [
        -3422.0,
        -5059.171875,
        1081.70703125
      ],
      [
        -3420.0,
        -5059.171875,
        1081.70703125
      ],
      [
        -3422.0,
        -5059.171875,
        1081.70703125
      ],
      [
        -3420.0,
        -5056.4853515625,
        1079.70703125
      ],
      [
        -3422.0,
        -5056.4853515625,
        1079.70703125
      ],
      [
        -3393.324462890625,
        -4925.00048828125,
        1079.70703125
      ],
      [
        -3406.675537109375,
        -4925.00048828125,
        1079.70703125
      ],
      [
        -3372.970947265625,
        -4940.70068359375,
        1079.70703125
      ],
      [
        -3381.29541015625,
        -4930.4365234375,
        1079.70703125
      ],
      [
        -3381.29541015625,
        -4930.4365234375,
        1079.70703125
      ],
      [
        -3393.324462890625,
        -4925.00048828125,
        1079.70703125
      ],
      [
        -3370.0,
        -4953.50048828125,
        1079.70703125
      ],
      [
        -3372.970947265625,
        -4940.70068359375,
        1079.70703125
      ],
      [
        -3406.675537109375,
        -4925.00048828125,
        1079.70703125
      ],
      [
        -3370.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3370.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1081.70703125
      ],
      [
        -3381.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3370.0,
        -5081.00048828125,
        1079.70703125
      ],
      [
        -3380.0,
        -5081.00048828125,
        1081.70703125
      ],
      [
        -3380.0,
        -5081.00048828125,
        1079.70703125
      ],
      [
        -3395.0,
        -5081.00048828125,
        1079.70703125
      ],
      [
        -3380.0,
        -5081.00048828125,
        1079.70703125
      ],
      [
        -3380.0,
        -5064.08447265625,
        1081.70703125
      ],
      [
        -3380.0,
        -5065.765625,
        1079.70703125
      ],
      [
        -3380.0,
        -5072.53564453125,
        1079.70703125
      ],
      [
        -3380.0,
        -5064.65087890625,
        1081.70703125
      ],
      [
        -3380.0,
        -5064.0107421875,
        1081.70703125
      ],
      [
        -3380.0,
        -5064.22021484375,
        1079.70703125
      ],
      [
        -3380.0,
        -5065.765625,
        1079.70703125
      ],
      [
        -3380.0,
        -5064.08447265625,
        1081.70703125
      ],
      [
        -3380.0,
        -5064.65087890625,
        1081.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1081.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3380.0,
        -5064.22021484375,
        1079.70703125
      ],
      [
        -3380.0,
        -5064.0107421875,
        1081.70703125
      ],
      [
        -3395.0,
        -5073.94580078125,
        1079.70703125
      ],
      [
        -3380.0,
        -5073.94580078125,
        1079.70703125
      ],
      [
        -3380.0,
        -5073.94580078125,
        1079.70703125
      ],
      [
        -3395.517578125,
        -5074.7861328125,
        1079.70703125
      ],
      [
        -3396.58251953125,
        -5079.41796875,
        1079.70703125
      ],
      [
        -3395.0,
        -5081.00048828125,
        1079.70703125
      ],
      [
        -3396.58251953125,
        -5079.41796875,
        1079.70703125
      ],
      [
        -3395.0,
        -5073.94580078125,
        1079.70703125
      ],
      [
        -3395.517578125,
        -5074.7861328125,
        1079.70703125
      ],
      [
        -3395.0,
        -5059.17236328125,
        1079.70703125
      ],
      [
        -3395.0,
        -5059.17236328125,
        1079.70703125
      ],
      [
        -3395.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3381.0,
        -5062.50048828125,
        1079.70703125
      ],
      [
        -3380.0,
        -5062.50048828125,
        1079.70703125
      ],
      [
        -3380.0,
        -5062.50048828125,
        1079.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3381.0,
        -5062.50048828125,
        1079.70703125
      ],
      [
        -3381.0,
        -5064.00048828125,
        1079.70703125
      ],
      [
        -3380.0,
        -4964.44189453125,
        1079.70703125
      ],
      [
        -3379.60009765625,
        -4962.00048828125,
        1081.70703125
      ],
      [
        -3378.0,
        -4971.76513671875,
        1081.70703125
      ],
      [
        -3378.0,
        -4976.6474609375,
        1079.70703125
      ],
      [
        -3378.0,
        -4966.8828125,
        1079.70703125
      ],
      [
        -3370.0,
        -4966.8828125,
        1079.70703125
      ],
      [
        -3377.0,
        -4962.00048828125,
        1079.70703125
      ],
      [
        -3379.60009765625,
        -4962.00048828125,
        1081.70703125
      ],
      [
        -3379.60009765625,
        -4953.50048828125,
        1081.70703125
      ],
      [
        -3377.0,
        -4962.00048828125,
        1079.70703125
      ],
      [
        -3380.0,
        -4964.44189453125,
        1079.70703125
      ],
      [
        -3378.0,
        -4976.6474609375,
        1079.70703125
      ],
      [
        -3378.0,
        -4971.76513671875,
        1081.70703125
      ],
      [
        -3378.0,
        -4966.8828125,
        1079.70703125
      ],
      [
        -3403.0,
        -5058.00048828125,
        1079.70703125
      ],
      [
        -3403.0,
        -5056.4853515625,
        1079.70703125
      ],
      [
        -3403.0,
        -5059.171875,
        1081.70703125
      ],
      [
        -3403.0,
        -5058.00048828125,
        1079.70703125
      ],
      [
        -3403.0,
        -5059.17236328125,
        1079.70703125
      ],
      [
        -3408.0,
        -4971.00048828125,
        1079.70703125
      ],
      [
        -3408.0,
        -4971.00048828125,
        1081.70703125
      ],
      [
        -3404.0,
        -4971.00048828125,
        1081.70703125
      ],
      [
        -3404.0,
        -4971.00048828125,
        1079.70703125
      ],
      [
        -3416.0,
        -4971.00048828125,
        1079.70703125
      ],
      [
        -3416.0,
        -4971.00048828125,
        1081.70703125
      ],
      [
        -3412.0,
        -4971.00048828125,
        1081.70703125
      ],
      [
        -3412.0,
        -4971.00048828125,
        1079.70703125
      ],
      [
        -3404.0,
        -4969.00048828125,
        1079.70703125
      ],
      [
        -3404.0,
        -4969.00048828125,
        1081.70703125
      ],
      [
        -3408.0,
        -4969.00048828125,
        1081.70703125
      ],
      [
        -3408.0,
        -4969.00048828125,
        1079.70703125
      ],
      [
        -3412.0,
        -4969.00048828125,
        1079.70703125
      ],
      [
        -3412.0,
        -4969.00048828125,
        1081.70703125
      ],
      [
        -3416.0,
        -4969.00048828125,
        1081.70703125
      ],
      [
        -3416.0,
        -4969.00048828125,
        1079.70703125
      ],
      [
        -3412.0,
        -4971.00048828125,
        1079.70703125
      ],
      [
        -3412.0,
        -4971.00048828125,
        1081.70703125
      ],
      [
        -3412.0,
        -4969.00048828125,
        1081.70703125
      ],
      [
        -3412.0,
        -4969.00048828125,
        1079.70703125
      ],
      [
        -3416.0,
        -4969.00048828125,
        1079.70703125
      ],
      [
        -3416.0,
        -4969.00048828125,
        1081.70703125
      ],
      [
        -3416.0,
        -4971.00048828125,
        1081.70703125
      ],
      [
        -3416.0,
        -4971.00048828125,
        1079.70703125
      ],
      [
        -3404.0,
        -4971.00048828125,
        1079.70703125
      ],
      [
        -3404.0,
        -4971.00048828125,
        1081.70703125
      ],
      [
        -3404.0,
        -4969.00048828125,
        1081.70703125
      ],
      [
        -3404.0,
        -4969.00048828125,
        1079.70703125
      ],
      [
        -3408.0,
        -4969.00048828125,
        1079.70703125
      ],
      [
        -3408.0,
        -4969.00048828125,
        1081.70703125
      ],
      [
        -3408.0,
        -4971.00048828125,
        1081.70703125
      ],
      [
        -3408.0,
        -4971.00048828125,
        1079.70703125
      ],
      [
        -3405.0,
        -5058.00048828125,
        1079.70703125
      ],
      [
        -3405.0,
        -5056.4853515625,
        1079.70703125
      ],
      [
        -3405.0,
        -5059.17236328125,
        1079.70703125
      ],
      [
        -3405.0,
        -5058.00048828125,
        1079.70703125
      ],
      [
        -3405.0,
        -5059.171875,
        1081.70703125
      ],
      [
        -3405.0,
        -5059.171875,
        1081.70703125
      ],
      [
        -3403.0,
        -5059.171875,
        1081.70703125
      ],
      [
        -3405.0,
        -5056.4853515625,
        1079.70703125
      ],
      [
        -3403.0,
        -5056.4853515625,
        1079.70703125
      ],
      [
        -3371.5,
        -5054.00048828125,
        1079.70703125
      ],
      [
        -3371.5,
        -5053.00048828125,
        1079.70703125
      ],
      [
        -3371.5,
        -5053.00048828125,
        1079.70703125
      ],
      [
        -3370.0,
        -5053.00048828125,
        1079.70703125
      ],
      [
        -3371.5,
        -5054.00048828125,
        1079.70703125
      ],
      [
        -3370.0,
        -5054.00048828125,
        1079.70703125
      ],
      [
        -3420.0,
        -4932.03369140625,
        1081.70703125
      ],
      [
        -3420.0,
        -4933.35546875,
        1085.7069091796875
      ],
      [
        -3418.458740234375,
        -4930.4365234375,
        1082.62451171875
      ],
      [
        -3418.000244140625,
        -4942.00048828125,
        1081.70703125
      ],
      [
        -3420.0,
        -4942.00048828125,
        1081.70703125
      ],
      [
        -3420.0,
        -4942.00048828125,
        1085.7069091796875
      ],
      [
        -3418.0,
        -4930.1181640625,
        1081.70703125
      ],
      [
        -3418.458740234375,
        -4930.4365234375,
        1082.62451171875
      ],
      [
        -3420.0,
        -5064.00048828125,
        1081.70703125
      ],
      [
        -3418.0,
        -5064.00048828125,
        1081.70703125
      ],
      [
        -3420.0,
        -5064.00048828125,
        1085.70703125
      ],
      [
        -3428.927978515625,
        -5016.20068359375,
        1085.70703125
      ],
      [
        -3428.927978515625,
        -5016.20068359375,
        1085.70703125
      ],
      [
        -3425.304931640625,
        -4950.13916015625,
        1096.31689453125
      ],
      [
        -3423.878662109375,
        -4940.70068359375,
        1093.4639892578125
      ],
      [
        -3425.304931640625,
        -5064.00048828125,
        1096.31689453125
      ],
      [
        -3425.66015625,
        -5064.00048828125,
        1097.0274658203125
      ],
      [
        -3425.304931640625,
        -5064.00048828125,
        1096.31689453125
      ],
      [
        -3423.878662109375,
        -4940.70068359375,
        1093.4639892578125
      ],
      [
        -3420.5,
        -4942.00048828125,
        1086.70703125
      ],
      [
        -3420.500244140625,
        -4934.7919921875,
        1086.70703125
      ],
      [
        -3420.5,
        -4942.00048828125,
        1086.70703125
      ],
      [
        -3425.304931640625,
        -4950.13916015625,
        1096.31689453125
      ],
      [
        -3425.66015625,
        -4953.50048828125,
        1097.0274658203125
      ],
      [
        -3425.66015625,
        -5039.00048828125,
        1097.0274658203125
      ],
      [
        -3424.0,
        -5039.00048828125,
        1093.706787109375
      ],
      [
        -3422.5,
        -5039.00048828125,
        1090.70703125
      ],
      [
        -3421.500244140625,
        -5039.00048828125,
        1088.70703125
      ],
      [
        -3424.0,
        -5043.00048828125,
        1093.706787109375
      ],
      [
        -3425.66015625,
        -5043.00048828125,
        1097.0274658203125
      ],
      [
        -3421.500244140625,
        -5043.00048828125,
        1088.70703125
      ],
      [
        -3422.5,
        -5043.00048828125,
        1090.70703125
      ],
      [
        -3421.500244140625,
        -5039.00048828125,
        1088.70703125
      ],
      [
        -3421.500244140625,
        -5043.00048828125,
        1088.70703125
      ],
      [
        -3424.0,
        -5043.00048828125,
        1093.706787109375
      ],
      [
        -3424.0,
        -5039.00048828125,
        1093.706787109375
      ],
      [
        -3422.5,
        -5043.00048828125,
        1090.70703125
      ],
      [
        -3422.5,
        -5039.00048828125,
        1090.70703125
      ],
      [
        -3424.0,
        -5035.00048828125,
        1093.706787109375
      ],
      [
        -3425.66015625,
        -5035.00048828125,
        1097.0274658203125
      ],
      [
        -3421.500244140625,
        -5035.00048828125,
        1088.70703125
      ],
      [
        -3422.5,
        -5035.00048828125,
        1090.70703125
      ],
      [
        -3425.66015625,
        -5031.00048828125,
        1097.0274658203125
      ],
      [
        -3424.0,
        -5031.00048828125,
        1093.706787109375
      ],
      [
        -3422.5,
        -5031.00048828125,
        1090.70703125
      ],
      [
        -3421.500244140625,
        -5031.00048828125,
        1088.70703125
      ],
      [
        -3421.500244140625,
        -5031.00048828125,
        1088.70703125
      ],
      [
        -3421.500244140625,
        -5035.00048828125,
        1088.70703125
      ],
      [
        -3424.0,
        -5035.00048828125,
        1093.706787109375
      ],
      [
        -3424.0,
        -5031.00048828125,
        1093.706787109375
      ],
      [
        -3422.5,
        -5035.00048828125,
        1090.70703125
      ],
      [
        -3422.5,
        -5031.00048828125,
        1090.70703125
      ],
      [
        -3418.999755859375,
        -4952.68212890625,
        1083.7064208984375
      ],
      [
        -3371.45166015625,
        -4951.8642578125,
        1085.7069091796875
      ],
      [
        -3370.3798828125,
        -4951.8642578125,
        1081.70703125
      ],
      [
        -3375.19677734375,
        -4947.642578125,
        1096.0272216796875
      ],
      [
        -3404.119140625,
        -4925.00048828125,
        1086.70703125
      ],
      [
        -3402.88671875,
        -4925.00048828125,
        1086.70703125
      ],
      [
        -3397.11328125,
        -4925.00048828125,
        1086.70703125
      ],
      [
        -3395.880859375,
        -4925.00048828125,
        1086.70703125
      ],
      [
        -3402.88671875,
        -4925.00048828125,
        1086.70703125
      ],
      [
        -3400.0,
        -4925.00048828125,
        1086.70703125
      ],
      [
        -3400.0,
        -4925.00048828125,
        1086.70703125
      ],
      [
        -3397.11328125,
        -4925.00048828125,
        1086.70703125
      ],
      [
        -3413.66552734375,
        -4942.00048828125,
        1105.3760986328125
      ],
      [
        -3400.0,
        -4942.00048828125,
        1109.037841796875
      ],
      [
        -3400.0,
        -4942.00048828125,
        1109.037841796875
      ],
      [
        -3386.33447265625,
        -4942.00048828125,
        1105.3760986328125
      ],
      [
        -3386.33447265625,
        -4942.00048828125,
        1105.3760986328125
      ],
      [
        -3376.3310546875,
        -4942.00048828125,
        1095.3724365234375
      ],
      [
        -3423.6689453125,
        -4942.00048828125,
        1095.3724365234375
      ],
      [
        -3413.66552734375,
        -4942.00048828125,
        1105.3760986328125
      ],
      [
        -3423.6689453125,
        -4942.00048828125,
        1095.3724365234375
      ],
      [
        -3424.074951171875,
        -4942.00048828125,
        1093.8568115234375
      ],
      [
        -3386.1396484375,
        -4943.68017578125,
        1105.7137451171875
      ],
      [
        -3375.19677734375,
        -4947.642578125,
        1096.0272216796875
      ],
      [
        -3424.80322265625,
        -4947.642578125,
        1096.0272216796875
      ],
      [
        -3413.8603515625,
        -4943.68017578125,
        1105.7137451171875
      ],
      [
        -3400.0,
        -4942.29248046875,
        1109.1055908203125
      ],
      [
        -3386.1396484375,
        -4943.68017578125,
        1105.7137451171875
      ],
      [
        -3413.8603515625,
        -4943.68017578125,
        1105.7137451171875
      ],
      [
        -3400.0,
        -4942.29248046875,
        1109.1055908203125
      ],
      [
        -3388.0,
        -4949.41015625,
        1091.70703125
      ],
      [
        -3382.0,
        -4949.40966796875,
        1091.70703125
      ],
      [
        -3418.0,
        -4949.40966796875,
        1091.70703125
      ],
      [
        -3412.0,
        -4949.41015625,
        1091.70703125
      ],
      [
        -3382.0,
        -4949.10302734375,
        1092.45703125
      ],
      [
        -3388.0,
        -4949.10302734375,
        1092.45703125
      ],
      [
        -3412.0,
        -4949.10302734375,
        1092.45703125
      ],
      [
        -3418.0,
        -4949.10302734375,
        1092.45703125
      ],
      [
        -3412.0,
        -4949.40966796875,
        1091.70703125
      ],
      [
        -3412.0,
        -4949.10302734375,
        1092.45703125
      ],
      [
        -3418.0,
        -4949.10302734375,
        1092.45703125
      ],
      [
        -3418.0,
        -4949.40966796875,
        1091.70703125
      ],
      [
        -3382.0,
        -4949.40966796875,
        1091.70703125
      ],
      [
        -3382.0,
        -4949.10302734375,
        1092.45703125
      ],
      [
        -3388.0,
        -4949.10302734375,
        1092.45703125
      ],
      [
        -3388.0,
        -4949.40966796875,
        1091.70703125
      ],
      [
        -3424.80322265625,
        -4947.642578125,
        1096.0272216796875
      ],
      [
        -3424.953125,
        -4947.81201171875,
        1095.6134033203125
      ],
      [
        -3409.0,
        -5036.92919921875,
        1090.70703125
      ],
      [
        -3409.0,
        -5040.92919921875,
        1090.70703125
      ],
      [
        -3413.0,
        -5038.58642578125,
        1088.70703125
      ],
      [
        -3409.0,
        -5036.92919921875,
        1088.70703125
      ],
      [
        -3409.0,
        -5036.92919921875,
        1090.70703125
      ],
      [
        -3413.0,
        -5038.58642578125,
        1090.70703125
      ],
      [
        -3413.0,
        -5042.58642578125,
        1090.70703125
      ],
      [
        -3409.0,
        -5040.92919921875,
        1090.70703125
      ],
      [
        -3409.0,
        -5040.92919921875,
        1088.70703125
      ],
      [
        -3413.0,
        -5042.58642578125,
        1088.70703125
      ],
      [
        -3413.0,
        -5034.58642578125,
        1090.70703125
      ],
      [
        -3413.0,
        -5034.58642578125,
        1088.70703125
      ],
      [
        -3412.0,
        -4956.35791015625,
        1090.70703125
      ],
      [
        -3412.0,
        -4953.50048828125,
        1090.70703125
      ],
      [
        -3412.0,
        -4953.50048828125,
        1090.70703125
      ],
      [
        -3412.0,
        -4952.7861328125,
        1090.70703125
      ],
      [
        -3413.0,
        -4971.00048828125,
        1090.70703125
      ],
      [
        -3413.0,
        -4969.00048828125,
        1088.70703125
      ],
      [
        -3412.0,
        -4956.35791015625,
        1090.70703125
      ],
      [
        -3409.0,
        -4956.35791015625,
        1090.70703125
      ],
      [
        -3412.0,
        -4952.7861328125,
        1090.70703125
      ],
      [
        -3409.0,
        -4952.7861328125,
        1090.70703125
      ],
      [
        -3409.0,
        -4953.50048828125,
        1091.70703125
      ],
      [
        -3409.0,
        -4969.00048828125,
        1091.70703125
      ],
      [
        -3412.0,
        -4953.50048828125,
        1091.70703125
      ],
      [
        -3409.0,
        -4953.50048828125,
        1092.45703125
      ],
      [
        -3409.0,
        -4953.50048828125,
        1091.70703125
      ],
      [
        -3412.0,
        -4953.50048828125,
        1108.4915771484375
      ],
      [
        -3409.0,
        -4953.50048828125,
        1109.29541015625
      ],
      [
        -3409.0,
        -4951.00048828125,
        1108.7152099609375
      ],
      [
        -3412.0,
        -4951.00048828125,
        1107.911376953125
      ],
      [
        -3409.0,
        -4943.193359375,
        1106.9031982421875
      ],
      [
        -3412.0,
        -4943.49365234375,
        1106.1690673828125
      ],
      [
        -3409.0,
        -4969.00048828125,
        1091.70703125
      ],
      [
        -3409.0,
        -4969.00048828125,
        1092.45703125
      ],
      [
        -3405.0,
        -5039.2724609375,
        1090.70703125
      ],
      [
        -3405.0,
        -5039.2724609375,
        1088.70703125
      ],
      [
        -3405.0,
        -4971.00048828125,
        1090.70703125
      ],
      [
        -3405.0,
        -4969.00048828125,
        1088.70703125
      ],
      [
        -3372.41162109375,
        -4953.50048828125,
        1090.70703125
      ],
      [
        -3371.875732421875,
        -4953.50048828125,
        1088.70703125
      ],
      [
        -3372.540283203125,
        -4950.63720703125,
        1088.70703125
      ],
      [
        -3373.26611328125,
        -4949.81884765625,
        1090.70703125
      ],
      [
        -3391.0,
        -4956.35791015625,
        1090.70703125
      ],
      [
        -3388.0,
        -4956.35791015625,
        1090.70703125
      ],
      [
        -3391.0,
        -4952.7861328125,
        1090.70703125
      ],
      [
        -3388.0,
        -4952.7861328125,
        1090.70703125
      ],
      [
        -3388.0,
        -4956.35791015625,
        1090.70703125
      ],
      [
        -3388.0,
        -4953.50048828125,
        1090.70703125
      ],
      [
        -3388.0,
        -4952.7861328125,
        1090.70703125
      ],
      [
        -3388.0,
        -4953.50048828125,
        1090.70703125
      ],
      [
        -3391.0,
        -4956.35791015625,
        1090.70703125
      ],
      [
        -3391.0,
        -4953.50048828125,
        1090.70703125
      ],
      [
        -3391.0,
        -4952.7861328125,
        1090.70703125
      ],
      [
        -3391.0,
        -4953.50048828125,
        1090.70703125
      ],
      [
        -3382.0,
        -4953.50048828125,
        1092.45703125
      ],
      [
        -3388.0,
        -4953.50048828125,
        1092.45703125
      ],
      [
        -3382.0,
        -4953.50048828125,
        1091.70703125
      ],
      [
        -3382.0,
        -4953.50048828125,
        1092.45703125
      ],
      [
        -3391.0,
        -4967.00048828125,
        1092.45703125
      ],
      [
        -3391.0,
        -4968.24755859375,
        1095.6563720703125
      ],
      [
        -3391.0,
        -4967.00048828125,
        1095.406982421875
      ],
      [
        -3391.0,
        -4967.00048828125,
        1094.8070068359375
      ],
      [
        -3391.0,
        -4965.00048828125,
        1095.007080078125
      ],
      [
        -3391.0,
        -4965.00048828125,
        1094.8070068359375
      ],
      [
        -3391.0,
        -4967.00048828125,
        1096.70703125
      ],
      [
        -3391.0,
        -4967.00048828125,
        1095.406982421875
      ],
      [
        -3391.0,
        -4953.50048828125,
        1091.70703125
      ],
      [
        -3388.0,
        -4953.50048828125,
        1091.70703125
      ],
      [
        -3372.6796875,
        -4953.50048828125,
        1091.70703125
      ],
      [
        -3373.62890625,
        -4949.40966796875,
        1091.70703125
      ],
      [
        -3378.808837890625,
        -4952.69140625,
        1083.6845703125
      ],
      [
        -3370.0,
        -4959.00048828125,
        1078.70703125
      ],
      [
        -3370.0,
        -4957.00048828125,
        1078.70703125
      ],
      [
        -3374.0,
        -4957.00048828125,
        1078.70703125
      ],
      [
        -3374.0,
        -4959.00048828125,
        1078.70703125
      ],
      [
        -3374.0,
        -4959.00048828125,
        1078.70703125
      ],
      [
        -3374.0,
        -4957.00048828125,
        1078.70703125
      ],
      [
        -3377.0,
        -4957.00048828125,
        1079.70703125
      ],
      [
        -3377.0,
        -4959.00048828125,
        1079.70703125
      ],
      [
        -3370.232177734375,
        -4952.50048828125,
        1079.70703125
      ],
      [
        -3396.0,
        -4945.00048828125,
        1056.70703125
      ],
      [
        -3396.0,
        -4948.00048828125,
        1056.70703125
      ],
      [
        -3392.0,
        -4945.00048828125,
        1056.70703125
      ],
      [
        -3396.0,
        -4945.00048828125,
        1056.70703125
      ],
      [
        -3392.0,
        -4948.00048828125,
        1056.70703125
      ],
      [
        -3392.0,
        -4945.00048828125,
        1056.70703125
      ],
      [
        -3396.0,
        -4948.00048828125,
        1056.70703125
      ],
      [
        -3392.0,
        -4948.00048828125,
        1056.70703125
      ],
      [
        -3396.0,
        -4948.00048828125,
        1074.5670166015625
      ],
      [
        -3392.0,
        -4948.00048828125,
        1074.5670166015625
      ],
      [
        -3408.0,
        -4945.00048828125,
        1056.70703125
      ],
      [
        -3412.0,
        -4945.00048828125,
        1056.70703125
      ],
      [
        -3408.0,
        -4948.00048828125,
        1056.70703125
      ],
      [
        -3408.0,
        -4945.00048828125,
        1056.70703125
      ],
      [
        -3412.0,
        -4945.00048828125,
        1056.70703125
      ],
      [
        -3412.0,
        -4948.00048828125,
        1056.70703125
      ],
      [
        -3412.0,
        -4948.00048828125,
        1056.70703125
      ],
      [
        -3408.0,
        -4948.00048828125,
        1056.70703125
      ],
      [
        -3412.0,
        -4948.00048828125,
        1074.5670166015625
      ],
      [
        -3408.0,
        -4948.00048828125,
        1074.5670166015625
      ],
      [
        -3381.0,
        -5064.00048828125,
        1056.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1056.70703125
      ],
      [
        -3405.0,
        -5056.00048828125,
        1070.70703125
      ],
      [
        -3403.0,
        -5056.00048828125,
        1070.70703125
      ],
      [
        -3403.0,
        -5056.00048828125,
        1073.70703125
      ],
      [
        -3405.0,
        -5056.00048828125,
        1073.70703125
      ],
      [
        -3405.0,
        -4999.00048828125,
        1070.70703125
      ],
      [
        -3405.0,
        -4999.00048828125,
        1073.70703125
      ],
      [
        -3403.0,
        -5064.00048828125,
        1063.70703125
      ],
      [
        -3403.0,
        -5058.34375,
        1066.0501708984375
      ],
      [
        -3403.0,
        -5058.34375,
        1066.0501708984375
      ],
      [
        -3403.0,
        -5056.00048828125,
        1070.70703125
      ],
      [
        -3420.0,
        -5055.7236328125,
        1067.135498046875
      ],
      [
        -3422.0,
        -5055.7236328125,
        1067.135498046875
      ],
      [
        -3420.0,
        -5055.7236328125,
        1067.135498046875
      ],
      [
        -3422.0,
        -5055.7236328125,
        1067.135498046875
      ],
      [
        -3405.0,
        -5055.7236328125,
        1067.135498046875
      ],
      [
        -3403.0,
        -5055.7236328125,
        1067.135498046875
      ],
      [
        -3405.0,
        -5055.7236328125,
        1067.135498046875
      ],
      [
        -3403.0,
        -5056.00048828125,
        1073.70703125
      ],
      [
        -3403.0,
        -5058.34375,
        1079.3638916015625
      ],
      [
        -3403.0,
        -5058.34375,
        1079.3638916015625
      ],
      [
        -3403.0,
        -5059.17236328125,
        1079.70703125
      ],
      [
        -3420.0,
        -5058.48583984375,
        1079.70703125
      ],
      [
        -3422.0,
        -5058.48583984375,
        1079.70703125
      ],
      [
        -3405.0,
        -5058.48583984375,
        1079.70703125
      ],
      [
        -3404.0,
        -5054.00048828125,
        1073.70703125
      ],
      [
        -3404.0,
        -5056.4853515625,
        1079.70703125
      ],
      [
        -3379.60009765625,
        -5003.50048828125,
        1064.7069091796875
      ],
      [
        -3379.60009765625,
        -4966.8828125,
        1079.70703125
      ],
      [
        -3374.0,
        -5010.8232421875,
        1061.70703125
      ],
      [
        -3379.60009765625,
        -5006.26708984375,
        1063.57373046875
      ],
      [
        -3370.0,
        -5010.8232421875,
        1061.70703125
      ],
      [
        -3374.0,
        -5010.8232421875,
        1061.70703125
      ],
      [
        -3380.0,
        -5005.94140625,
        1063.70703125
      ],
      [
        -3379.60009765625,
        -5003.50048828125,
        1064.7069091796875
      ],
      [
        -3380.0,
        -5005.94140625,
        1063.70703125
      ],
      [
        -3378.0,
        -5017.3349609375,
        1063.0404052734375
      ],
      [
        -3378.0,
        -5007.56884765625,
        1063.0404052734375
      ],
      [
        -3379.60009765625,
        -5006.26708984375,
        1063.57373046875
      ],
      [
        -3378.0,
        -5034.00048828125,
        1063.0404052734375
      ],
      [
        -3378.0,
        -5035.6669921875,
        1065.3736572265625
      ],
      [
        -3378.0,
        -5036.333984375,
        1063.70703125
      ],
      [
        -3378.0,
        -5035.6669921875,
        1065.3736572265625
      ],
      [
        -3378.0,
        -5034.00048828125,
        1063.0404052734375
      ],
      [
        -3378.0,
        -5036.333984375,
        1063.70703125
      ],
      [
        -3380.0,
        -5061.00048828125,
        1063.706787109375
      ],
      [
        -3380.0,
        -5061.00048828125,
        1056.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1056.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1063.7066650390625
      ],
      [
        -3380.0,
        -5061.00048828125,
        1056.70703125
      ],
      [
        -3380.0,
        -5061.00048828125,
        1063.706787109375
      ],
      [
        -3381.0,
        -5061.00048828125,
        1061.206787109375
      ],
      [
        -3381.0,
        -5061.00048828125,
        1056.70703125
      ],
      [
        -3381.0,
        -5061.00048828125,
        1056.70703125
      ],
      [
        -3381.0,
        -5061.00048828125,
        1061.206787109375
      ],
      [
        -3381.0,
        -5064.00048828125,
        1061.2066650390625
      ],
      [
        -3381.0,
        -5064.00048828125,
        1056.70703125
      ],
      [
        -3374.0,
        -5040.6005859375,
        1064.70703125
      ],
      [
        -3378.0,
        -5035.93359375,
        1064.70703125
      ],
      [
        -3374.0,
        -5040.6005859375,
        1064.70703125
      ],
      [
        -3370.0,
        -5040.6005859375,
        1064.70703125
      ],
      [
        -3373.0,
        -5053.00048828125,
        1064.70703125
      ],
      [
        -3373.0,
        -5053.00048828125,
        1061.70703125
      ],
      [
        -3370.0,
        -5053.00048828125,
        1061.70703125
      ],
      [
        -3370.0,
        -5053.00048828125,
        1064.70703125
      ],
      [
        -3373.0,
        -5054.00048828125,
        1061.70703125
      ],
      [
        -3373.0,
        -5054.00048828125,
        1064.70703125
      ],
      [
        -3370.0,
        -5054.00048828125,
        1064.70703125
      ],
      [
        -3370.0,
        -5054.00048828125,
        1061.70703125
      ],
      [
        -3373.0,
        -5053.00048828125,
        1061.70703125
      ],
      [
        -3373.0,
        -5053.00048828125,
        1064.70703125
      ],
      [
        -3373.0,
        -5054.00048828125,
        1064.70703125
      ],
      [
        -3373.0,
        -5054.00048828125,
        1061.70703125
      ],
      [
        -3373.0,
        -5053.00048828125,
        1061.3736572265625
      ],
      [
        -3370.0,
        -5053.00048828125,
        1060.3736572265625
      ],
      [
        -3373.0,
        -5054.00048828125,
        1061.3736572265625
      ],
      [
        -3370.0,
        -5054.00048828125,
        1060.3736572265625
      ],
      [
        -3373.0,
        -5053.00048828125,
        1061.3736572265625
      ],
      [
        -3373.0,
        -5054.00048828125,
        1061.3736572265625
      ],
      [
        -3373.0,
        -5053.00048828125,
        1056.70703125
      ],
      [
        -3370.0,
        -5053.00048828125,
        1056.70703125
      ],
      [
        -3373.0,
        -5054.00048828125,
        1056.70703125
      ],
      [
        -3370.0,
        -5054.00048828125,
        1056.70703125
      ],
      [
        -3373.0,
        -5053.00048828125,
        1056.70703125
      ],
      [
        -3373.0,
        -5054.00048828125,
        1056.70703125
      ],
      [
        -3377.0,
        -4959.5595703125,
        1079.70703125
      ],
      [
        -3370.0,
        -4980.00048828125,
        1036.70703125
      ],
      [
        -3378.0,
        -4980.00048828125,
        1036.70703125
      ],
      [
        -3380.0,
        -4980.00048828125,
        1041.70703125
      ],
      [
        -3378.0,
        -4988.00048828125,
        1036.70703125
      ],
      [
        -3370.0,
        -4988.00048828125,
        1036.70703125
      ],
      [
        -3380.0,
        -4988.00048828125,
        1041.70703125
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3370.0,
      "bbox_min": [
        -3480.0,
        -5310.0,
        810.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4650.0,
        1330.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2980.000244140625,
      "bbox_min": [
        -3370.0,
        -5095.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -2980.000244140625,
        -4957.00048828125,
        1140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.11588192731142044,
        0.0,
        0.9932630062103271
      ],
      "plane_d": -1432.636962890625,
      "bbox_min": [
        -3370.0,
        -5095.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3195.000244140625,
        -4957.00048828125,
        1085.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1065337285399437,
        0.9943090677261353,
        0.0
      ],
      "plane_d": 4650.06201171875,
      "bbox_min": [
        -3370.0,
        -5095.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3195.000244140625,
        -4957.00048828125,
        1085.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5035.00048828125,
      "bbox_min": [
        -3370.0,
        -5095.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3247.0,
        -5024.57177734375,
        1080.6070556640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9882413744926453,
        -0.15290136635303497,
        -0.0
      ],
      "plane_d": -4088.143798828125,
      "bbox_min": [
        -3370.0,
        -5095.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3353.89990234375,
        -5036.416015625,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1124890148639679,
        0.9936529397964478
      ],
      "plane_d": -1624.1627197265625,
      "bbox_min": [
        -3370.0,
        -5095.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3353.89990234375,
        -5036.416015625,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9882413744926453,
        0.15290136635303497,
        -0.0
      ],
      "plane_d": 4094.0732421875,
      "bbox_min": [
        -3370.0,
        -5095.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3353.89990234375,
        -5036.416015625,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.39391934871673584,
        -0.9191451072692871
      ],
      "plane_d": 2992.073486328125,
      "bbox_min": [
        -3370.0,
        -5095.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3358.306396484375,
        -5060.00048828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1061.70703125,
      "bbox_min": [
        -3370.0,
        -5095.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3358.306396484375,
        -5060.00048828125,
        1077.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1210.562255859375,
      "bbox_min": [
        -3362.0,
        -5073.95654296875,
        1061.70703125
      ],
      "bbox_max": [
        -3358.306396484375,
        -5060.00048828125,
        1071.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25884392857551575,
        0.9659191370010376,
        0.0
      ],
      "plane_d": 4030.798583984375,
      "bbox_min": [
        -3362.0,
        -5073.95654296875,
        1061.70703125
      ],
      "bbox_max": [
        -3358.306396484375,
        -5060.00048828125,
        1071.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659172892570496,
        -0.2588512599468231,
        0.0
      ],
      "plane_d": 1935.5980224609375,
      "bbox_min": [
        -3362.0,
        -5073.95654296875,
        1061.70703125
      ],
      "bbox_max": [
        -3358.306396484375,
        -5060.00048828125,
        1071.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071534991264343,
        -0.7070600986480713,
        0.0
      ],
      "plane_d": -1204.373046875,
      "bbox_min": [
        -3362.0,
        -5067.8359375,
        1061.70703125
      ],
      "bbox_max": [
        -3361.253173828125,
        -5065.05029296875,
        1071.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1071.8070068359375,
      "bbox_min": [
        -3362.0,
        -5067.8359375,
        1071.8070068359375
      ],
      "bbox_max": [
        -3361.253173828125,
        -5065.05029296875,
        1071.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1071.8070068359375,
      "bbox_min": [
        -3362.0,
        -5073.95654296875,
        1071.8070068359375
      ],
      "bbox_max": [
        -3358.306396484375,
        -5060.00048828125,
        1071.8070068359375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5095.00048828125,
      "bbox_min": [
        -3370.0,
        -5095.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3362.0,
        -5080.50048828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1064.70703125,
      "bbox_min": [
        -3370.0,
        -5095.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3362.0,
        -5080.50048828125,
        1077.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5081.00048828125,
      "bbox_min": [
        -3370.0,
        -5095.00048828125,
        1064.70703125
      ],
      "bbox_max": [
        -3362.0,
        -5080.50048828125,
        1077.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5080.50048828125,
      "bbox_min": [
        -3369.0,
        -5081.00048828125,
        1065.70703125
      ],
      "bbox_max": [
        -3365.0,
        -5080.50048828125,
        1069.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5145573616027832,
        0.8574560284614563
      ],
      "plane_d": -3528.26318359375,
      "bbox_min": [
        -3369.0,
        -5081.00048828125,
        1065.70703125
      ],
      "bbox_max": [
        -3365.0,
        -5080.50048828125,
        1069.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1069.20703125,
      "bbox_min": [
        -3369.0,
        -5081.00048828125,
        1065.70703125
      ],
      "bbox_max": [
        -3365.0,
        -5080.50048828125,
        1069.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3365.0,
      "bbox_min": [
        -3369.0,
        -5081.00048828125,
        1065.70703125
      ],
      "bbox_max": [
        -3365.0,
        -5080.50048828125,
        1069.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3369.0,
      "bbox_min": [
        -3369.0,
        -5081.00048828125,
        1065.70703125
      ],
      "bbox_max": [
        -3369.0,
        -5080.50048828125,
        1069.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19610844552516937,
        0.0,
        0.9805821776390076
      ],
      "plane_d": -1704.3299560546875,
      "bbox_min": [
        -3370.0,
        -5095.00048828125,
        1064.70703125
      ],
      "bbox_max": [
        -3362.0,
        -5081.00048828125,
        1065.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3365.0,
      "bbox_min": [
        -3367.00048828125,
        -5095.00048828125,
        1064.70703125
      ],
      "bbox_max": [
        -3365.0,
        -5083.50048828125,
        1065.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5083.50048828125,
      "bbox_min": [
        -3367.00048828125,
        -5083.50048828125,
        1064.70703125
      ],
      "bbox_max": [
        -3365.0,
        -5083.50048828125,
        1065.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5083.50048828125,
      "bbox_min": [
        -3370.0,
        -5083.50048828125,
        1064.70703125
      ],
      "bbox_max": [
        -3365.0,
        -5083.50048828125,
        1065.1070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5081.00048828125,
      "bbox_min": [
        -3370.0,
        -5081.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3362.0,
        -5081.00048828125,
        1064.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1071.8070068359375,
      "bbox_min": [
        -3370.0,
        -5076.1005859375,
        1061.70703125
      ],
      "bbox_max": [
        -3362.0,
        -5065.79736328125,
        1071.8070068359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25879597663879395,
        -0.9659320116043091,
        0.0
      ],
      "plane_d": -4025.22998046875,
      "bbox_min": [
        -3370.0,
        -5070.1005859375,
        1061.70703125
      ],
      "bbox_max": [
        -3362.0,
        -5065.79736328125,
        1071.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071534991264343,
        -0.7070600986480713,
        0.0
      ],
      "plane_d": -1204.373046875,
      "bbox_min": [
        -3364.949951171875,
        -5068.74755859375,
        1061.70703125
      ],
      "bbox_max": [
        -3362.0,
        -5065.79736328125,
        1071.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.1124890148639679,
        -0.9936529397964478
      ],
      "plane_d": 1634.1986083984375,
      "bbox_min": [
        -3363.450927734375,
        -5070.2998046875,
        1061.70703125
      ],
      "bbox_max": [
        -3353.89990234375,
        -5036.416015625,
        1074.4769287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1071.806884765625,
      "bbox_min": [
        -3359.89990234375,
        -5070.2998046875,
        1070.6409912109375
      ],
      "bbox_max": [
        -3353.89990234375,
        -5060.00048828125,
        1071.8070068359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1210.562255859375,
      "bbox_min": [
        -3359.89990234375,
        -5070.2998046875,
        1061.70703125
      ],
      "bbox_max": [
        -3353.89990234375,
        -5060.00048828125,
        1070.895751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1061.70703125,
      "bbox_min": [
        -3359.89990234375,
        -5070.2998046875,
        1061.70703125
      ],
      "bbox_max": [
        -3353.89990234375,
        -5060.00048828125,
        1061.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3295.0,
      "bbox_min": [
        -3295.0,
        -5035.00048828125,
        1075.0
      ],
      "bbox_max": [
        -3295.0,
        -5029.71484375,
        1080.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1064.699951171875,
      "bbox_min": [
        -3318.0,
        -5035.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -5024.57177734375,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1065.8070068359375,
      "bbox_min": [
        -3318.0,
        -5035.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -5024.57177734375,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3247.0,
      "bbox_min": [
        -3247.0,
        -5035.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -5024.57177734375,
        1065.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3247.0,
      "bbox_min": [
        -3247.0,
        -5035.00048828125,
        1065.8070068359375
      ],
      "bbox_max": [
        -3247.0,
        -5024.57177734375,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1064.699951171875,
      "bbox_min": [
        -3370.0,
        -5037.048828125,
        1064.3052978515625
      ],
      "bbox_max": [
        -3195.000244140625,
        -4957.00048828125,
        1085.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        -0.1124890148639679,
        0.9936529397964478
      ],
      "plane_d": -1624.1627197265625,
      "bbox_min": [
        -3363.990234375,
        -5037.048828125,
        1064.3052978515625
      ],
      "bbox_max": [
        -3357.548828125,
        -5033.56298828125,
        1064.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9882413744926453,
        -0.15290136635303497,
        -0.0
      ],
      "plane_d": -4088.143798828125,
      "bbox_min": [
        -3357.990234375,
        -5036.416015625,
        1064.376953125
      ],
      "bbox_max": [
        -3357.548828125,
        -5033.56298828125,
        1064.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01190398819744587,
        -0.9999291896820068,
        -0.0
      ],
      "plane_d": -5041.6787109375,
      "bbox_min": [
        -3370.0,
        -5037.048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3195.000244140625,
        -4957.00048828125,
        1085.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1084.70703125,
      "bbox_min": [
        -3352.72607421875,
        -5003.2255859375,
        1064.699951171875
      ],
      "bbox_max": [
        -3260.0546875,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.5555756092071533,
        -0.8314660787582397,
        0.0
      ],
      "plane_d": -2277.62353515625,
      "bbox_min": [
        -3352.72607421875,
        -5003.2255859375,
        1064.699951171875
      ],
      "bbox_max": [
        -3260.0546875,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950886994600296,
        -0.980785608291626,
        -0.0
      ],
      "plane_d": -5506.8154296875,
      "bbox_min": [
        -3352.72607421875,
        -5003.2255859375,
        1064.699951171875
      ],
      "bbox_max": [
        -3260.0546875,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950886994600296,
        -0.980785608291626,
        0.0
      ],
      "plane_d": -4216.69384765625,
      "bbox_min": [
        -3352.72607421875,
        -5003.2255859375,
        1064.699951171875
      ],
      "bbox_max": [
        -3260.0546875,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314619064331055,
        -0.55558180809021,
        0.0
      ],
      "plane_d": 14.9814453125,
      "bbox_min": [
        -3352.72607421875,
        -5003.2255859375,
        1064.699951171875
      ],
      "bbox_max": [
        -3260.0546875,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555756092071533,
        -0.8314660787582397,
        -0.0
      ],
      "plane_d": -5951.6455078125,
      "bbox_min": [
        -3352.72607421875,
        -5003.2255859375,
        1064.699951171875
      ],
      "bbox_max": [
        -3260.0546875,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314619064331055,
        -0.55558180809021,
        -0.0
      ],
      "plane_d": -5483.4765625,
      "bbox_min": [
        -3352.72607421875,
        -5003.2255859375,
        1064.699951171875
      ],
      "bbox_max": [
        -3260.0546875,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.70703125,
      "bbox_min": [
        -3352.72607421875,
        -5003.2255859375,
        1064.699951171875
      ],
      "bbox_max": [
        -3260.0546875,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.400073379278183,
        -0.5985084176063538,
        -0.6940669417381287
      ],
      "plane_d": -3536.025390625,
      "bbox_min": [
        -3352.72607421875,
        -5003.2255859375,
        1077.70703125
      ],
      "bbox_max": [
        -3260.0546875,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5987338423728943,
        -0.400060772895813,
        -0.6938797235488892
      ],
      "plane_d": -3200.158447265625,
      "bbox_min": [
        -3352.72607421875,
        -5003.2255859375,
        1077.70703125
      ],
      "bbox_max": [
        -3260.0546875,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14045031368732452,
        -0.7060664892196655,
        -0.6940776705741882
      ],
      "plane_d": -3215.736328125,
      "bbox_min": [
        -3352.72607421875,
        -5003.2255859375,
        1077.70703125
      ],
      "bbox_max": [
        -3260.0546875,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14044855535030365,
        -0.7060576677322388,
        -0.6940869688987732
      ],
      "plane_d": -2286.890380859375,
      "bbox_min": [
        -3352.72607421875,
        -5003.2255859375,
        1077.70703125
      ],
      "bbox_max": [
        -3260.0546875,
        -4957.00048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3307.5,
      "bbox_min": [
        -3352.72607421875,
        -5003.2255859375,
        1077.70703125
      ],
      "bbox_max": [
        -3260.0546875,
        -4957.19921875,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807851910591125,
        -0.19509129226207733,
        -0.0
      ],
      "plane_d": -4173.4990234375,
      "bbox_min": [
        -3307.5,
        -5003.2255859375,
        1077.70703125
      ],
      "bbox_max": [
        -3260.0546875,
        -4985.70556640625,
        1080.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5879262685775757,
        -0.3928711712360382,
        -0.7071031928062439
      ],
      "plane_d": -3137.6875,
      "bbox_min": [
        -3307.5,
        -5002.83154296875,
        1077.70703125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4990.03955078125,
        1080.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555580258369446,
        -0.8314778208732605,
        0.0
      ],
      "plane_d": -5984.05029296875,
      "bbox_min": [
        -3307.5,
        -5002.83154296875,
        1077.70703125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4990.03955078125,
        1080.33935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -5539.3427734375,
      "bbox_min": [
        -3307.5,
        -5002.83154296875,
        1077.70703125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4990.03955078125,
        1080.33935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314491510391235,
        -0.5556010007858276,
        0.0
      ],
      "plane_d": -5515.9345703125,
      "bbox_min": [
        -3307.5,
        -5002.83154296875,
        1077.70703125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4990.03955078125,
        1080.33935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6996876001358032,
        -0.14448051154613495,
        -0.6996876001358032
      ],
      "plane_d": -2272.291748046875,
      "bbox_min": [
        -3307.5,
        -5002.83154296875,
        1077.70703125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4990.03955078125,
        1080.33935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -4248.87060546875,
      "bbox_min": [
        -3307.5,
        -4990.23828125,
        1077.70703125
      ],
      "bbox_max": [
        -3306.5,
        -4990.03955078125,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7059730887413025,
        -0.14071038365364075,
        -0.6941199898719788
      ],
      "plane_d": 2411.7685546875,
      "bbox_min": [
        -3352.72607421875,
        -5002.466796875,
        1077.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4985.48486328125,
        1084.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807845950126648,
        -0.19509392976760864,
        0.0
      ],
      "plane_d": 2312.41845703125,
      "bbox_min": [
        -3352.72607421875,
        -5002.466796875,
        1077.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4985.48486328125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5349685549736023,
        0.8006280660629272,
        -0.26982107758522034
      ],
      "plane_d": 2511.330078125,
      "bbox_min": [
        -3325.78955078125,
        -5002.466796875,
        1077.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4985.48486328125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9444068670272827,
        0.18784846365451813,
        -0.26983052492141724
      ],
      "plane_d": -1908.51025390625,
      "bbox_min": [
        -3325.78955078125,
        -5002.466796875,
        1077.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4990.23828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -4248.87060546875,
      "bbox_min": [
        -3311.651123046875,
        -4991.064453125,
        1077.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4990.23828125,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807845950126648,
        -0.19509392976760864,
        0.0
      ],
      "plane_d": 2312.41845703125,
      "bbox_min": [
        -3352.72607421875,
        -5002.85546875,
        1064.699951171875
      ],
      "bbox_max": [
        -3291.12841796875,
        -4957.19921875,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3307.5,
      "bbox_min": [
        -3307.5,
        -4967.00048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3307.5,
        -4957.19921875,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1065.800048828125,
      "bbox_min": [
        -3323.79443359375,
        -5002.85546875,
        1064.699951171875
      ],
      "bbox_max": [
        -3291.12841796875,
        -4977.00048828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3307.5,
      "bbox_min": [
        -3322.796630859375,
        -5002.478515625,
        1064.699951171875
      ],
      "bbox_max": [
        -3307.5,
        -4977.00048828125,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314606547355652,
        0.5555837750434875,
        0.0
      ],
      "plane_d": 14.455810546875,
      "bbox_min": [
        -3322.796630859375,
        -5002.478515625,
        1064.699951171875
      ],
      "bbox_max": [
        -3312.814208984375,
        -4988.25634765625,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555574893951416,
        0.8314781188964844,
        0.0
      ],
      "plane_d": 2307.16748046875,
      "bbox_min": [
        -3322.796630859375,
        -5002.478515625,
        1064.699951171875
      ],
      "bbox_max": [
        -3312.814208984375,
        -4988.25634765625,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807901382446289,
        0.19506590068340302,
        0.0
      ],
      "plane_d": -2283.1533203125,
      "bbox_min": [
        -3322.796630859375,
        -5002.478515625,
        1064.699951171875
      ],
      "bbox_max": [
        -3321.744140625,
        -4997.18603515625,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807836413383484,
        -0.1950991004705429,
        -0.0
      ],
      "plane_d": -4203.9375,
      "bbox_min": [
        -3323.79443359375,
        -5002.85546875,
        1065.800048828125
      ],
      "bbox_max": [
        -3291.12841796875,
        -4977.00048828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19506025314331055,
        -0.9807913303375244,
        -0.0
      ],
      "plane_d": -5537.154296875,
      "bbox_min": [
        -3323.79443359375,
        -5002.85546875,
        1065.800048828125
      ],
      "bbox_max": [
        -3291.12841796875,
        -4977.00048828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3307.5,
      "bbox_min": [
        -3307.5,
        -4987.8017578125,
        1065.800048828125
      ],
      "bbox_max": [
        -3307.5,
        -4977.00048828125,
        1077.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5556128025054932,
        -0.8314412832260132,
        -0.0
      ],
      "plane_d": -5982.04833984375,
      "bbox_min": [
        -3323.79443359375,
        -5002.85546875,
        1065.800048828125
      ],
      "bbox_max": [
        -3291.12841796875,
        -4987.33251953125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1069.70703125,
      "bbox_min": [
        -3323.79443359375,
        -5002.85546875,
        1065.800048828125
      ],
      "bbox_max": [
        -3291.12841796875,
        -4987.33251953125,
        1077.70703125
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.8314606547355652,
        0.5555837750434875,
        0.0
      ],
      "plane_d": 14.455810546875,
      "bbox_min": [
        -3322.796630859375,
        -5002.83154296875,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4987.8017578125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555574893951416,
        0.8314781188964844,
        0.0
      ],
      "plane_d": 2307.16748046875,
      "bbox_min": [
        -3322.796630859375,
        -5002.83154296875,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4987.8017578125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39665111899375916,
        0.5936500430107117,
        0.7001767754554749
      ],
      "plane_d": 898.96337890625,
      "bbox_min": [
        -3322.796630859375,
        -5002.83154296875,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4987.8017578125,
        1069.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19514167308807373,
        -0.9807751178741455,
        -0.0
      ],
      "plane_d": -5539.34228515625,
      "bbox_min": [
        -3322.796630859375,
        -5002.83154296875,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4987.8017578125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3307.5,
      "bbox_min": [
        -3307.5,
        -4988.19921875,
        1069.3095703125
      ],
      "bbox_max": [
        -3307.5,
        -4987.8017578125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555580258369446,
        -0.8314778208732605,
        -0.0
      ],
      "plane_d": -5984.05029296875,
      "bbox_min": [
        -3322.796630859375,
        -5002.83154296875,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4990.03955078125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314491510391235,
        -0.5556010007858276,
        -0.0
      ],
      "plane_d": -5515.9345703125,
      "bbox_min": [
        -3322.796630859375,
        -5002.83154296875,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4990.03955078125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5935388803482056,
        0.39660394191741943,
        0.7002977132797241
      ],
      "plane_d": -738.0936279296875,
      "bbox_min": [
        -3322.796630859375,
        -5002.83154296875,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4990.03955078125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -4248.87060546875,
      "bbox_min": [
        -3322.796630859375,
        -5002.83154296875,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4990.03955078125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807901382446289,
        0.19506590068340302,
        0.0
      ],
      "plane_d": -2283.1533203125,
      "bbox_min": [
        -3322.796630859375,
        -5002.83154296875,
        1065.800048828125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4997.18603515625,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7002162337303162,
        0.1392635554075241,
        0.7002162337303162
      ],
      "plane_d": -2378.33935546875,
      "bbox_min": [
        -3322.796630859375,
        -5002.49072265625,
        1068.70703125
      ],
      "bbox_max": [
        -3320.820068359375,
        -4997.18603515625,
        1069.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5556128025054932,
        0.8314412832260132,
        0.0
      ],
      "plane_d": 2307.781005859375,
      "bbox_min": [
        -3323.79443359375,
        -5002.85546875,
        1069.70703125
      ],
      "bbox_max": [
        -3291.12841796875,
        -4987.33251953125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19506025314331055,
        -0.9807913303375244,
        0.0
      ],
      "plane_d": -4247.220703125,
      "bbox_min": [
        -3323.79443359375,
        -5002.85546875,
        1069.70703125
      ],
      "bbox_max": [
        -3291.12841796875,
        -4987.8017578125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3307.5,
      "bbox_min": [
        -3307.5,
        -4988.19921875,
        1069.70703125
      ],
      "bbox_max": [
        -3307.5,
        -4987.8017578125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 1075.7069091796875,
      "bbox_min": [
        -3323.79443359375,
        -5002.85546875,
        1069.70703125
      ],
      "bbox_max": [
        -3291.12841796875,
        -4988.00048828125,
        1077.70703125
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.593612551689148,
        0.3966447710990906,
        -0.7002121210098267
      ],
      "plane_d": 764.2021484375,
      "bbox_min": [
        -3323.79443359375,
        -5002.83154296875,
        1075.70703125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4990.03955078125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555580258369446,
        -0.8314778208732605,
        0.0
      ],
      "plane_d": -5984.05029296875,
      "bbox_min": [
        -3311.651123046875,
        -5002.83154296875,
        1075.70703125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4990.03955078125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -4248.87060546875,
      "bbox_min": [
        -3311.651123046875,
        -5002.83154296875,
        1075.70703125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4990.03955078125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19514167308807373,
        -0.9807751178741455,
        0.0
      ],
      "plane_d": -5539.3427734375,
      "bbox_min": [
        -3306.5,
        -5002.83154296875,
        1075.70703125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4990.03955078125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314491510391235,
        -0.5556010007858276,
        0.0
      ],
      "plane_d": -5515.9345703125,
      "bbox_min": [
        -3296.981689453125,
        -5002.83154296875,
        1075.70703125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4993.982421875,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9793387651443481,
        -0.20222648978233337,
        0.0
      ],
      "plane_d": -4236.802734375,
      "bbox_min": [
        -3294.063720703125,
        -5002.83154296875,
        1075.70703125
      ],
      "bbox_max": [
        -3293.13818359375,
        -4998.34912109375,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4988.19921875,
      "bbox_min": [
        -3307.5,
        -4988.19921875,
        1069.70703125
      ],
      "bbox_max": [
        -3305.5,
        -4988.19921875,
        1075.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39665064215660095,
        0.5936230421066284,
        -0.7001999616622925
      ],
      "plane_d": 2401.024169921875,
      "bbox_min": [
        -3321.72265625,
        -4995.38916015625,
        1075.70703125
      ],
      "bbox_max": [
        -3312.431640625,
        -4987.33251953125,
        1077.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.593612551689148,
        0.3966447710990906,
        -0.7002121210098267
      ],
      "plane_d": 764.2021484375,
      "bbox_min": [
        -3321.72265625,
        -4995.38916015625,
        1075.70703125
      ],
      "bbox_max": [
        -3317.460205078125,
        -4991.1259765625,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5023.50048828125,
      "bbox_min": [
        -3370.0,
        -5037.048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3237.0,
        -5002.1220703125,
        1084.70703125
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        -3364.0,
        -5037.048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -5023.5,
        1080.6070556640625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3295.0,
      "bbox_min": [
        -3295.0,
        -5029.71484375,
        1075.0
      ],
      "bbox_max": [
        -3295.0,
        -5023.50048828125,
        1080.6070556640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1065.8070068359375,
      "bbox_min": [
        -3364.0,
        -5037.048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -5023.5,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3364.0,
      "bbox_min": [
        -3364.0,
        -5037.048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -5023.5,
        1065.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3358.0,
      "bbox_min": [
        -3364.0,
        -5037.048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -5023.5,
        1065.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9882413744926453,
        -0.15290136635303497,
        -0.0
      ],
      "plane_d": -4088.143798828125,
      "bbox_min": [
        -3358.0,
        -5036.416015625,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -5023.5,
        1065.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3247.0,
      "bbox_min": [
        -3247.0,
        -5024.57177734375,
        1064.699951171875
      ],
      "bbox_max": [
        -3247.0,
        -5023.5,
        1065.8070068359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.1124890148639679,
        0.9936529397964478
      ],
      "plane_d": -1624.1627197265625,
      "bbox_min": [
        -3364.0,
        -5037.048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3358.0,
        -5033.50048828125,
        1064.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9882413744926453,
        0.15290136635303497,
        -0.0
      ],
      "plane_d": 4094.0732421875,
      "bbox_min": [
        -3364.0,
        -5037.048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3363.450927734375,
        -5033.50048828125,
        1064.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3358.0,
      "bbox_min": [
        -3364.0,
        -5037.048828125,
        1065.8070068359375
      ],
      "bbox_max": [
        -3247.0,
        -5023.5,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9882413744926453,
        -0.15290136635303497,
        -0.0
      ],
      "plane_d": -4088.143798828125,
      "bbox_min": [
        -3358.0,
        -5036.46435546875,
        1065.8070068359375
      ],
      "bbox_max": [
        -3247.0,
        -5023.5,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3247.0,
      "bbox_min": [
        -3295.0,
        -5024.57177734375,
        1065.8070068359375
      ],
      "bbox_max": [
        -3247.0,
        -5023.5,
        1075.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3295.0,
      "bbox_min": [
        -3295.0,
        -5024.50048828125,
        1065.8070068359375
      ],
      "bbox_max": [
        -3295.0,
        -5023.50048828125,
        1075.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.1124890148639679,
        -0.9936529397964478
      ],
      "plane_d": 1634.1986083984375,
      "bbox_min": [
        -3358.0,
        -5036.46435546875,
        1074.471435546875
      ],
      "bbox_max": [
        -3357.548828125,
        -5033.50048828125,
        1074.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1074.8070068359375,
      "bbox_min": [
        -3364.0,
        -5037.048828125,
        1065.8070068359375
      ],
      "bbox_max": [
        -3358.0,
        -5023.50048828125,
        1074.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9882413744926453,
        0.15290136635303497,
        -0.0
      ],
      "plane_d": 4094.0732421875,
      "bbox_min": [
        -3364.0,
        -5037.048828125,
        1065.8070068359375
      ],
      "bbox_max": [
        -3358.0,
        -5033.50048828125,
        1074.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.1124890148639679,
        -0.9936529397964478
      ],
      "plane_d": 1634.1986083984375,
      "bbox_min": [
        -3364.0,
        -5037.048828125,
        1074.4052734375
      ],
      "bbox_max": [
        -3358.0,
        -5033.50048828125,
        1074.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1084.70703125,
      "bbox_min": [
        -3370.0,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3237.0,
        -5002.1220703125,
        1084.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1065.800048828125,
      "bbox_min": [
        -3370.0,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3237.0,
        -5002.1220703125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0004164811398368329,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1063.3033447265625,
      "bbox_min": [
        -3370.0,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3237.0,
        -5002.1220703125,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5003.5,
      "bbox_min": [
        -3370.0,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3237.0,
        -5002.1220703125,
        1065.800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9807901382446289,
        0.19506590068340302,
        0.0
      ],
      "plane_d": -2283.1533203125,
      "bbox_min": [
        -3353.000244140625,
        -5003.5009765625,
        1064.699951171875
      ],
      "bbox_max": [
        -3260.0,
        -5002.1220703125,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807851910591125,
        -0.19509129226207733,
        -0.0
      ],
      "plane_d": -4173.4990234375,
      "bbox_min": [
        -3260.0546875,
        -5003.5,
        1064.699951171875
      ],
      "bbox_max": [
        -3260.0,
        -5003.2255859375,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807845950126648,
        -0.19509392976760864,
        0.0
      ],
      "plane_d": 2312.41845703125,
      "bbox_min": [
        -3353.000244140625,
        -5003.5009765625,
        1064.699951171875
      ],
      "bbox_max": [
        -3352.72607421875,
        -5002.1220703125,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -3323.0,
        -5023.50048828125,
        1064.699951171875
      ],
      "bbox_max": [
        -3323.0,
        -5003.50048828125,
        1065.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5003.5,
      "bbox_min": [
        -3370.0,
        -5023.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3237.0,
        -5002.1220703125,
        1084.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807845950126648,
        -0.19509392976760864,
        0.0
      ],
      "plane_d": 2312.41845703125,
      "bbox_min": [
        -3353.000244140625,
        -5003.5009765625,
        1065.800048828125
      ],
      "bbox_max": [
        -3260.0,
        -5002.1220703125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807851910591125,
        -0.19509129226207733,
        -0.0
      ],
      "plane_d": -4173.4990234375,
      "bbox_min": [
        -3353.000244140625,
        -5003.5009765625,
        1065.800048828125
      ],
      "bbox_max": [
        -3260.0,
        -5002.1220703125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7056561708450317,
        -0.1403709203004837,
        -0.694510817527771
      ],
      "plane_d": 2412.826171875,
      "bbox_min": [
        -3353.000244140625,
        -5003.5009765625,
        1065.800048828125
      ],
      "bbox_max": [
        -3291.0,
        -5002.1220703125,
        1084.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9807836413383484,
        0.1950991004705429,
        0.0
      ],
      "plane_d": -2281.98486328125,
      "bbox_min": [
        -3326.0,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3291.0,
        -5002.44287109375,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807836413383484,
        -0.1950991004705429,
        -0.0
      ],
      "plane_d": -4203.9375,
      "bbox_min": [
        -3295.0,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3291.0,
        -5002.81103515625,
        1080.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9793387651443481,
        -0.20222648978233337,
        -0.0
      ],
      "plane_d": -4236.802734375,
      "bbox_min": [
        -3295.0,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3291.0,
        -5002.81103515625,
        1080.6070556640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1075.70703125,
      "bbox_min": [
        -3293.13818359375,
        -5003.50048828125,
        1069.70703125
      ],
      "bbox_max": [
        -3291.0,
        -5002.83154296875,
        1075.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1069.70703125,
      "bbox_min": [
        -3293.13818359375,
        -5003.50048828125,
        1069.70703125
      ],
      "bbox_max": [
        -3291.0,
        -5002.83154296875,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6996876001358032,
        -0.14448051154613495,
        -0.6996876001358032
      ],
      "plane_d": -2272.291748046875,
      "bbox_min": [
        -3295.0,
        -5003.50048828125,
        1078.6070556640625
      ],
      "bbox_max": [
        -3293.0,
        -5002.81103515625,
        1080.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9444068670272827,
        0.18784846365451813,
        -0.26983052492141724
      ],
      "plane_d": -1908.51025390625,
      "bbox_min": [
        -3326.0,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3321.799072265625,
        -5002.44287109375,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7002139091491699,
        0.13928771018981934,
        -0.7002139091491699
      ],
      "plane_d": -875.95947265625,
      "bbox_min": [
        -3324.0,
        -5003.50048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3321.799072265625,
        -5002.466796875,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807901382446289,
        0.19506590068340302,
        0.0
      ],
      "plane_d": -2283.1533203125,
      "bbox_min": [
        -3323.0,
        -5003.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3321.799072265625,
        -5002.478515625,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7002162337303162,
        0.1392635554075241,
        0.7002162337303162
      ],
      "plane_d": -2378.33935546875,
      "bbox_min": [
        -3323.0,
        -5003.50048828125,
        1068.70703125
      ],
      "bbox_max": [
        -3321.799072265625,
        -5002.478515625,
        1069.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1078.5999755859375,
      "bbox_min": [
        -3370.0,
        -5023.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3237.0,
        -5003.5,
        1084.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7127070426940918,
        0.0,
        -0.7014617323875427
      ],
      "plane_d": 3146.31103515625,
      "bbox_min": [
        -3353.000244140625,
        -5023.50048828125,
        1078.5999755859375
      ],
      "bbox_max": [
        -3293.0,
        -5003.50048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9615240097045898,
        -0.0,
        -0.2747211456298828
      ],
      "plane_d": -2900.036865234375,
      "bbox_min": [
        -3326.0,
        -5023.50048828125,
        1078.5999755859375
      ],
      "bbox_max": [
        -3293.0,
        -5003.50048828125,
        1084.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -1565.812255859375,
      "bbox_min": [
        -3295.0,
        -5023.50048828125,
        1078.5999755859375
      ],
      "bbox_max": [
        -3293.0,
        -5003.50048828125,
        1080.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3293.0,
      "bbox_min": [
        -3293.0,
        -5023.50048828125,
        1078.5999755859375
      ],
      "bbox_max": [
        -3293.0,
        -5003.50048828125,
        1078.6070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -3324.255126953125,
        -5023.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3291.0,
        -5003.50048828125,
        1078.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3291.0,
      "bbox_min": [
        -3293.0,
        -5023.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3291.0,
        -5003.50048828125,
        1078.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3293.0,
      "bbox_min": [
        -3293.0,
        -5023.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3291.0,
        -5003.50048828125,
        1078.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1075.70703125,
      "bbox_min": [
        -3293.0,
        -5023.50048828125,
        1069.70703125
      ],
      "bbox_max": [
        -3291.0,
        -5003.50048828125,
        1075.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1069.70703125,
      "bbox_min": [
        -3293.0,
        -5023.50048828125,
        1069.70703125
      ],
      "bbox_max": [
        -3291.0,
        -5003.50048828125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -1588.3690185546875,
      "bbox_min": [
        -3324.255126953125,
        -5023.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3322.0,
        -5003.50048828125,
        1078.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9615240097045898,
        -0.0,
        -0.2747211456298828
      ],
      "plane_d": -2900.036865234375,
      "bbox_min": [
        -3324.255126953125,
        -5023.50048828125,
        1077.70703125
      ],
      "bbox_max": [
        -3324.0,
        -5003.50048828125,
        1078.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -3323.0,
        -5023.50048828125,
        1065.800048828125
      ],
      "bbox_max": [
        -3322.0,
        -5003.50048828125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -3105.40625,
      "bbox_min": [
        -3323.0,
        -5023.50048828125,
        1068.70703125
      ],
      "bbox_max": [
        -3322.0,
        -5003.50048828125,
        1069.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1041.70703125,
      "bbox_min": [
        -3370.0,
        -5094.0,
        1036.70703125
      ],
      "bbox_max": [
        -2980.000244140625,
        -4953.50048828125,
        1056.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2980.000244140625,
      "bbox_min": [
        -2980.000244140625,
        -5094.0,
        1036.70703125
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1041.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3355.0,
      "bbox_min": [
        -3370.0,
        -5094.0,
        1041.70703125
      ],
      "bbox_max": [
        -2980.000244140625,
        -4953.50048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2980.000244140625,
      "bbox_min": [
        -2980.000244140625,
        -5094.0,
        1041.70703125
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1056.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25766268372535706,
        -0.0,
        -0.9662350416183472
      ],
      "plane_d": 152.7041015625,
      "bbox_min": [
        -3370.0,
        -5079.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3355.0,
        -4953.50048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1208.446044921875,
      "bbox_min": [
        -3370.0,
        -5079.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3355.0,
        -4953.50048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2495131641626358,
        0.2495131641626358,
        -0.9356743097305298
      ],
      "plane_d": 1411.4091796875,
      "bbox_min": [
        -3370.0,
        -5079.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3355.0,
        -4953.50048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4953.50048828125,
      "bbox_min": [
        -3370.0,
        -4953.50048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3355.0,
        -4953.50048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2980.000244140625,
      "bbox_min": [
        -2980.000244140625,
        -5094.0,
        980.0
      ],
      "bbox_max": [
        -2980.000244140625,
        -4976.0,
        1036.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3430.0,
      "bbox_min": [
        -3475.0,
        -5095.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1111.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1096.70703125,
      "bbox_min": [
        -3475.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1081.70703125,
      "bbox_min": [
        -3475.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5018.20068359375,
      "bbox_min": [
        -3475.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4968.89990234375,
      "bbox_min": [
        -3475.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8933590054512024,
        -0.44934356212615967
      ],
      "plane_d": -3948.08984375,
      "bbox_min": [
        -3475.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8863697648048401,
        0.46297794580459595
      ],
      "plane_d": -4906.951171875,
      "bbox_min": [
        -3475.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8881837129592896,
        0.45948854088783264
      ],
      "plane_d": 3958.275634765625,
      "bbox_min": [
        -3475.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3430.0,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4989.00048828125,
      "bbox_min": [
        -3475.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3434.5,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3460.0,
      "bbox_min": [
        -3460.0,
        -4989.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3434.5,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4979.00048828125,
      "bbox_min": [
        -3460.0,
        -4989.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3434.5,
        -4979.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4988.00048828125,
      "bbox_min": [
        -3460.0,
        -4989.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3434.5,
        -4979.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.29825839400291443,
        0.9544851183891296
      ],
      "plane_d": 448.7374267578125,
      "bbox_min": [
        -3460.0,
        -4988.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3434.5,
        -4979.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277936935425,
        0.9486833810806274
      ],
      "plane_d": -2607.336669921875,
      "bbox_min": [
        -3460.0,
        -4988.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3434.5,
        -4979.00048828125,
        1088.5194091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1086.70703125,
      "bbox_min": [
        -3460.0,
        -4988.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3434.5,
        -4979.00048828125,
        1086.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1085.20703125,
      "bbox_min": [
        -3460.0,
        -4988.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3434.5,
        -4979.00048828125,
        1086.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3452.5,
      "bbox_min": [
        -3460.0,
        -4988.00048828125,
        1085.20703125
      ],
      "bbox_max": [
        -3434.5,
        -4979.00048828125,
        1086.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3434.5,
      "bbox_min": [
        -3434.5,
        -4988.00048828125,
        1085.20703125
      ],
      "bbox_max": [
        -3434.5,
        -4979.00048828125,
        1086.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4987.50048828125,
      "bbox_min": [
        -3460.0,
        -4988.00048828125,
        1085.20703125
      ],
      "bbox_max": [
        -3459.5,
        -4987.50048828125,
        1085.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3459.5,
      "bbox_min": [
        -3459.5,
        -4988.00048828125,
        1085.20703125
      ],
      "bbox_max": [
        -3459.5,
        -4987.50048828125,
        1085.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4985.00048828125,
      "bbox_min": [
        -3460.0,
        -4988.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3435.5,
        -4981.00048828125,
        1085.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1260.06298828125,
      "bbox_min": [
        -3451.5,
        -4985.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3435.5,
        -4981.00048828125,
        1085.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3450.5,
      "bbox_min": [
        -3450.5,
        -4985.00048828125,
        1082.20703125
      ],
      "bbox_max": [
        -3450.5,
        -4982.00048828125,
        1083.7069091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3436.5,
      "bbox_min": [
        -3450.5,
        -4985.00048828125,
        1082.20703125
      ],
      "bbox_max": [
        -3436.5,
        -4982.00048828125,
        1085.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        0.8944271802902222
      ],
      "plane_d": -2511.06591796875,
      "bbox_min": [
        -3451.5,
        -4986.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3450.5,
        -4985.00048828125,
        1082.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3459.5,
      "bbox_min": [
        -3460.0,
        -4988.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3459.5,
        -4987.50048828125,
        1085.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4987.50048828125,
      "bbox_min": [
        -3460.0,
        -4987.50048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3459.5,
        -4987.50048828125,
        1085.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3459.5,
      "bbox_min": [
        -3460.0,
        -4988.00048828125,
        1085.70703125
      ],
      "bbox_max": [
        -3459.5,
        -4987.50048828125,
        1088.5194091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4987.50048828125,
      "bbox_min": [
        -3460.0,
        -4987.50048828125,
        1085.873779296875
      ],
      "bbox_max": [
        -3459.5,
        -4987.50048828125,
        1088.3631591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4987.50048828125,
      "bbox_min": [
        -3460.0,
        -4988.00048828125,
        1088.3631591796875
      ],
      "bbox_max": [
        -3459.5,
        -4987.50048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3459.5,
      "bbox_min": [
        -3459.5,
        -4988.00048828125,
        1088.3631591796875
      ],
      "bbox_max": [
        -3459.5,
        -4987.50048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5001.00048828125,
      "bbox_min": [
        -3475.0,
        -5001.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3460.0,
        -4989.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3475.0,
      "bbox_min": [
        -3475.0,
        -5001.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3475.0,
        -4989.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4999.00048828125,
      "bbox_min": [
        -3460.0,
        -5008.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3434.5,
        -4999.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5008.00048828125,
      "bbox_min": [
        -3460.0,
        -5008.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3434.5,
        -4999.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3459.5,
      "bbox_min": [
        -3460.0,
        -5008.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3434.5,
        -4999.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5002.50048828125,
      "bbox_min": [
        -3460.0,
        -5002.50048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3459.5,
        -5001.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5001.00048828125,
      "bbox_min": [
        -3460.0,
        -5001.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3459.5,
        -5001.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.29825839400291443,
        0.9544851183891296
      ],
      "plane_d": -2529.969482421875,
      "bbox_min": [
        -3452.5,
        -5008.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3434.5,
        -4999.00048828125,
        1086.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3162277936935425,
        0.9486833810806274
      ],
      "plane_d": 550.8306884765625,
      "bbox_min": [
        -3452.5,
        -5008.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3434.5,
        -4999.00048828125,
        1086.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1086.70703125,
      "bbox_min": [
        -3452.5,
        -5008.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3434.5,
        -4999.00048828125,
        1086.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1085.20703125,
      "bbox_min": [
        -3452.5,
        -5008.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3434.5,
        -4999.00048828125,
        1086.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3434.5,
      "bbox_min": [
        -3452.5,
        -5008.00048828125,
        1085.20703125
      ],
      "bbox_max": [
        -3434.5,
        -4999.00048828125,
        1086.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3452.5,
      "bbox_min": [
        -3452.5,
        -5008.00048828125,
        1085.20703125
      ],
      "bbox_max": [
        -3452.5,
        -4999.00048828125,
        1086.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5005.00048828125,
      "bbox_min": [
        -3451.5,
        -5006.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3435.5,
        -5001.00048828125,
        1085.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1269.00732421875,
      "bbox_min": [
        -3451.5,
        -5005.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3435.5,
        -5001.00048828125,
        1085.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3450.5,
      "bbox_min": [
        -3450.5,
        -5005.00048828125,
        1082.20703125
      ],
      "bbox_max": [
        -3450.5,
        -5002.00048828125,
        1083.7069091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3436.5,
      "bbox_min": [
        -3450.5,
        -5005.00048828125,
        1082.20703125
      ],
      "bbox_max": [
        -3436.5,
        -5002.00048828125,
        1085.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659250378608704,
        0.0,
        -0.2588219940662384
      ],
      "plane_d": -2975.197998046875,
      "bbox_min": [
        -3430.0,
        -5095.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1111.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1081.8070068359375,
      "bbox_min": [
        -3370.02685546875,
        -5081.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5064.00048828125,
        1081.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5064.00048828125,
      "bbox_min": [
        -3370.02685546875,
        -5081.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5064.00048828125,
        1081.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5081.00048828125,
      "bbox_min": [
        -3370.02685546875,
        -5081.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5081.00048828125,
        1081.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588219940662384,
        0.0,
        -0.9659250378608704
      ],
      "plane_d": 193.8309326171875,
      "bbox_min": [
        -3430.0,
        -5095.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1111.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588219940662384,
        0.0,
        -0.9659250378608704
      ],
      "plane_d": 1953.820556640625,
      "bbox_min": [
        -3430.0,
        -5095.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1111.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 3198.0234375,
      "bbox_min": [
        -3430.0,
        -5095.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1111.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1096.70703125,
      "bbox_min": [
        -3430.0,
        -5018.20068359375,
        1092.6864013671875
      ],
      "bbox_max": [
        -3425.980712890625,
        -4968.97900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8933590054512024,
        -0.44934356212615967
      ],
      "plane_d": -3948.08984375,
      "bbox_min": [
        -3430.0,
        -5018.20068359375,
        1092.6864013671875
      ],
      "bbox_max": [
        -3425.980712890625,
        -4968.97900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8953441381454468,
        -0.4453750550746918
      ],
      "plane_d": 4979.671875,
      "bbox_min": [
        -3430.0,
        -5018.20068359375,
        1092.6864013671875
      ],
      "bbox_max": [
        -3425.980712890625,
        -5016.20068359375,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -1610.3031005859375,
      "bbox_min": [
        -3430.0,
        -5095.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1111.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1079.70703125,
      "bbox_min": [
        -3430.0,
        -5095.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1111.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1081.70703125,
      "bbox_min": [
        -3430.0,
        -5081.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1111.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3418.0,
      "bbox_min": [
        -3430.0,
        -5081.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7766754627227783,
        -0.629901111125946,
        0.0
      ],
      "plane_d": -450.46337890625,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4930.1181640625,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9741045236587524,
        -0.2260982245206833,
        0.0
      ],
      "plane_d": 2221.20068359375,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4930.1181640625,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5064.00048828125,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3418.0,
        -5064.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4118106961250305,
        -0.9112694263458252,
        0.0
      ],
      "plane_d": -3085.096923828125,
      "bbox_min": [
        -3418.70458984375,
        -4930.4365234375,
        1079.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4930.1181640625,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 3419.999755859375,
      "bbox_min": [
        -3422.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3420.0,
        -5056.4853515625,
        1081.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3422.0,
      "bbox_min": [
        -3422.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3420.0,
        -5056.4853515625,
        1081.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9238893389701843,
        0.38265982270240784
      ],
      "plane_d": 4258.47265625,
      "bbox_min": [
        -3422.0,
        -5056.92919921875,
        1079.70703125
      ],
      "bbox_max": [
        -3420.0,
        -5056.4853515625,
        1080.778076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4953.50048828125,
      "bbox_min": [
        -3418.0,
        -5081.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4925.00048828125,
      "bbox_min": [
        -3418.0,
        -4953.50048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7766754627227783,
        -0.629901111125946,
        -0.0
      ],
      "plane_d": -5731.8564453125,
      "bbox_min": [
        -3418.0,
        -4953.50048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4118106961250305,
        -0.9112694263458252,
        -0.0
      ],
      "plane_d": -5885.40966796875,
      "bbox_min": [
        -3418.0,
        -4953.50048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9741045236587524,
        -0.2260982245206833,
        -0.0
      ],
      "plane_d": -4402.7099609375,
      "bbox_min": [
        -3418.0,
        -4953.50048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4118106961250305,
        -0.9112694263458252,
        0.0
      ],
      "plane_d": -3085.096923828125,
      "bbox_min": [
        -3418.0,
        -4930.1181640625,
        1079.70703125
      ],
      "bbox_max": [
        -3406.675537109375,
        -4925.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5064.00048828125,
      "bbox_min": [
        -3418.0,
        -5081.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4953.50048828125,
        1081.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5081.00048828125,
      "bbox_min": [
        -3396.58251953125,
        -5081.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5064.00048828125,
        1081.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.22993531823158264,
        -0.9732059836387634
      ],
      "plane_d": -115.5777587890625,
      "bbox_min": [
        -3396.58251953125,
        -5081.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5064.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3380.0,
      "bbox_min": [
        -3380.0,
        -5081.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5064.00048828125,
        1081.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.6157490611076355,
        -0.7879424095153809
      ],
      "plane_d": -2273.5302734375,
      "bbox_min": [
        -3396.58251953125,
        -5081.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5072.53564453125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 3379.999755859375,
      "bbox_min": [
        -3380.0,
        -5074.556640625,
        1079.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5072.53564453125,
        1080.1845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070902585983276,
        -0.16259263455867767,
        -0.688176691532135
      ],
      "plane_d": 2318.84375,
      "bbox_min": [
        -3396.58251953125,
        -5081.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3395.0,
        -5073.94580078125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 5993.4375,
      "bbox_min": [
        -3396.58251953125,
        -5081.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3395.0,
        -5073.94580078125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071056365966797,
        -0.43540096282958984,
        -0.5571601986885071
      ],
      "plane_d": 792.99267578125,
      "bbox_min": [
        -3395.517578125,
        -5074.7861328125,
        1079.70703125
      ],
      "bbox_max": [
        -3395.0,
        -5073.94580078125,
        1080.1845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.38268932700157166,
        0.9238771796226501
      ],
      "plane_d": 938.5745239257812,
      "bbox_min": [
        -3418.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4953.50048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.800000011920929,
        0.6000000238418579
      ],
      "plane_d": 3402.17626953125,
      "bbox_min": [
        -3381.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5062.50048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3380.0,
      "bbox_min": [
        -3381.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5062.50048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3381.0,
      "bbox_min": [
        -3381.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3381.0,
        -5062.50048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9179146885871887,
        -0.15040530264377594,
        0.36716586351394653
      ],
      "plane_d": -4245.66162109375,
      "bbox_min": [
        -3416.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4953.50048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.37906694412231445,
        0.9253692626953125
      ],
      "plane_d": -2881.90869140625,
      "bbox_min": [
        -3380.0,
        -4976.6474609375,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4953.50048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162277936935425,
        0.0,
        -0.9486833810806274
      ],
      "plane_d": -43.6011962890625,
      "bbox_min": [
        -3380.0,
        -4964.44189453125,
        1079.70703125
      ],
      "bbox_max": [
        -3377.0,
        -4953.50048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": -3539.61572265625,
      "bbox_min": [
        -3380.0,
        -4962.00048828125,
        1080.70703125
      ],
      "bbox_max": [
        -3379.60009765625,
        -4953.50048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.294752836227417,
        0.36222636699676514,
        -0.8842583894729614
      ],
      "plane_d": 1756.72705078125,
      "bbox_min": [
        -3380.0,
        -4964.44189453125,
        1079.70703125
      ],
      "bbox_max": [
        -3377.0,
        -4962.00048828125,
        1080.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3378.0,
      "bbox_min": [
        -3378.0,
        -4976.6474609375,
        1079.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4962.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3403.0,
      "bbox_min": [
        -3416.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4969.00048828125,
        1081.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4971.00048828125,
      "bbox_min": [
        -3416.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4969.00048828125,
        1081.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4969.00048828125,
      "bbox_min": [
        -3416.0,
        -4971.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4969.00048828125,
        1081.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3412.0,
      "bbox_min": [
        -3416.0,
        -4971.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4969.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3416.0,
      "bbox_min": [
        -3416.0,
        -4971.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3416.0,
        -4969.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3404.0,
      "bbox_min": [
        -3408.0,
        -4971.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4969.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3408.0,
      "bbox_min": [
        -3408.0,
        -4971.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3408.0,
        -4969.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3405.0,
      "bbox_min": [
        -3405.0,
        -5064.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5056.4853515625,
        1081.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9238893389701843,
        0.38265982270240784
      ],
      "plane_d": 4258.47265625,
      "bbox_min": [
        -3405.0,
        -5056.92919921875,
        1079.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5056.4853515625,
        1080.778076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        0.0,
        0.6000000238418579
      ],
      "plane_d": -3345.024169921875,
      "bbox_min": [
        -3371.5,
        -5054.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5053.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5053.00048828125,
      "bbox_min": [
        -3371.5,
        -5054.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5053.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5054.00048828125,
      "bbox_min": [
        -3371.5,
        -5054.00048828125,
        1079.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5054.00048828125,
        1081.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.0,
        0.44721364974975586
      ],
      "plane_d": 2573.3984375,
      "bbox_min": [
        -3430.0,
        -5081.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1111.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3420.0,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4930.1181640625,
        1097.0274658203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6332069635391235,
        0.773982584476471,
        0.0
      ],
      "plane_d": 1668.355224609375,
      "bbox_min": [
        -3420.0,
        -4953.5009765625,
        1081.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4930.1181640625,
        1085.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7603828310966492,
        -0.6166874766349792,
        -0.2037513554096222
      ],
      "plane_d": -220.615234375,
      "bbox_min": [
        -3420.0,
        -4942.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4930.1181640625,
        1085.7069091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4942.00048828125,
      "bbox_min": [
        -3420.0,
        -4942.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4930.1181640625,
        1085.7069091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.409326434135437,
        -0.9057720899581909,
        -0.10967516154050827
      ],
      "plane_d": -2947.849609375,
      "bbox_min": [
        -3418.70458984375,
        -4930.4365234375,
        1081.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4930.1181640625,
        1082.62451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5064.00048828125,
      "bbox_min": [
        -3420.0,
        -5064.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3418.0,
        -5064.00048828125,
        1085.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659250974655151,
        0.0,
        -0.2588219940662384
      ],
      "plane_d": 3593.092529296875,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3420.0,
        -4932.03369140625,
        1097.0274658203125
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5018.20068359375,
      "bbox_min": [
        -3430.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3425.980712890625,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4968.89990234375,
      "bbox_min": [
        -3430.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3425.980712890625,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8933590054512024,
        -0.44934356212615967
      ],
      "plane_d": -3948.08984375,
      "bbox_min": [
        -3430.0,
        -5018.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3425.980712890625,
        -4968.900390625,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5016.20068359375,
      "bbox_min": [
        -3430.0,
        -5017.2177734375,
        1081.70703125
      ],
      "bbox_max": [
        -3428.927978515625,
        -5016.20068359375,
        1085.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5064.00048828125,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3420.0,
        -4932.03369140625,
        1097.0274658203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5016.20068359375,
      "bbox_min": [
        -3430.0,
        -5016.20068359375,
        1081.70703125
      ],
      "bbox_max": [
        -3420.0,
        -4934.7919921875,
        1097.0274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6899776458740234,
        -0.2187732309103012,
        -0.6899776458740234
      ],
      "plane_d": 2036.860107421875,
      "bbox_min": [
        -3425.980712890625,
        -4953.50048828125,
        1096.31689453125
      ],
      "bbox_max": [
        -3425.304931640625,
        -4950.13916015625,
        1097.0274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5039.00048828125,
      "bbox_min": [
        -3428.0,
        -5064.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3420.0,
        -5031.00048828125,
        1097.0274658203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5043.00048828125,
      "bbox_min": [
        -3428.0,
        -5064.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3420.0,
        -5039.00048828125,
        1097.0274658203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1088.70703125,
      "bbox_min": [
        -3428.0,
        -5043.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3421.500244140625,
        -5039.00048828125,
        1093.706787109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3424.0,
      "bbox_min": [
        -3424.0,
        -5043.00048828125,
        1090.70703125
      ],
      "bbox_max": [
        -3422.5,
        -5039.00048828125,
        1093.706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1090.70703125,
      "bbox_min": [
        -3424.0,
        -5043.00048828125,
        1090.70703125
      ],
      "bbox_max": [
        -3422.5,
        -5039.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38267579674720764,
        0.923882782459259
      ],
      "plane_d": 936.6521606445312,
      "bbox_min": [
        -3422.0,
        -5064.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3420.0,
        -5059.171875,
        1083.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3422.0,
      "bbox_min": [
        -3422.0,
        -5064.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3422.0,
        -5059.171875,
        1083.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5031.00048828125,
      "bbox_min": [
        -3428.0,
        -5035.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3421.500244140625,
        -5031.00048828125,
        1097.0274658203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1088.70703125,
      "bbox_min": [
        -3428.0,
        -5035.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3421.500244140625,
        -5031.00048828125,
        1093.706787109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3424.0,
      "bbox_min": [
        -3424.0,
        -5035.00048828125,
        1090.70703125
      ],
      "bbox_max": [
        -3422.5,
        -5031.00048828125,
        1093.706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1090.70703125,
      "bbox_min": [
        -3424.0,
        -5035.00048828125,
        1090.70703125
      ],
      "bbox_max": [
        -3422.5,
        -5031.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5064.00048828125,
      "bbox_min": [
        -3425.66015625,
        -5081.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1111.70703125
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5081.00048828125,
      "bbox_min": [
        -3380.0,
        -5081.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5081.00048828125,
        1081.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 5891.2607421875,
      "bbox_min": [
        -3418.999755859375,
        -4953.50048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4951.8642578125,
        1085.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6332069635391235,
        0.773982584476471,
        0.0
      ],
      "plane_d": 1668.355224609375,
      "bbox_min": [
        -3418.999755859375,
        -4952.68212890625,
        1081.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4951.8642578125,
        1085.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20374414324760437,
        -0.6166828870773315,
        -0.7603884339332581
      ],
      "plane_d": -2896.50537109375,
      "bbox_min": [
        -3424.953125,
        -4951.8642578125,
        1081.70703125
      ],
      "bbox_max": [
        -3370.3798828125,
        -4925.00048828125,
        1109.1055908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7603887915611267,
        -0.6166794896125793,
        -0.20375293493270874
      ],
      "plane_d": -5391.197265625,
      "bbox_min": [
        -3424.953125,
        -4951.8642578125,
        1081.70703125
      ],
      "bbox_max": [
        -3370.3798828125,
        -4925.00048828125,
        1109.1055908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5566467046737671,
        -0.6166881918907166,
        -0.556632936000824
      ],
      "plane_d": -4316.8046875,
      "bbox_min": [
        -3424.953125,
        -4951.8642578125,
        1081.70703125
      ],
      "bbox_max": [
        -3370.3798828125,
        -4925.00048828125,
        1109.1055908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5566498041152954,
        -0.6166824698448181,
        -0.5566360950469971
      ],
      "plane_d": -531.5643310546875,
      "bbox_min": [
        -3424.953125,
        -4951.8642578125,
        1081.70703125
      ],
      "bbox_max": [
        -3370.3798828125,
        -4925.00048828125,
        1109.1055908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9425258040428162,
        -0.2187749594449997,
        -0.2525521218776703
      ],
      "plane_d": -3986.826416015625,
      "bbox_min": [
        -3424.953125,
        -4951.8642578125,
        1081.70703125
      ],
      "bbox_max": [
        -3370.3798828125,
        -4925.00048828125,
        1109.1055908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4942.00048828125,
      "bbox_min": [
        -3424.953125,
        -4949.41015625,
        1081.70703125
      ],
      "bbox_max": [
        -3372.97119140625,
        -4925.00048828125,
        1109.1055908203125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.2996492087841034,
        -0.9057707190513611,
        -0.2996492087841034
      ],
      "plane_d": -5152.86376953125,
      "bbox_min": [
        -3424.074951171875,
        -4942.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3374.31103515625,
        -4925.00048828125,
        1109.037841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29964742064476013,
        -0.9057719707489014,
        -0.29964742064476013
      ],
      "plane_d": -3115.2626953125,
      "bbox_min": [
        -3424.074951171875,
        -4942.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3374.31103515625,
        -4925.00048828125,
        1109.037841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10968045145273209,
        -0.9057716727256775,
        -0.4093262255191803
      ],
      "plane_d": -4388.33544921875,
      "bbox_min": [
        -3424.074951171875,
        -4942.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3374.31103515625,
        -4925.00048828125,
        1109.037841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10968038439750671,
        -0.905771791934967,
        -0.4093259871006012
      ],
      "plane_d": -3642.51025390625,
      "bbox_min": [
        -3424.074951171875,
        -4942.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3374.31103515625,
        -4925.00048828125,
        1109.037841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4093274772167206,
        -0.9057716727256775,
        -0.10967544466257095
      ],
      "plane_d": -5731.27001953125,
      "bbox_min": [
        -3424.074951171875,
        -4942.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3374.31103515625,
        -4925.00048828125,
        1109.037841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.409326434135437,
        -0.9057720899581909,
        -0.10967516154050827
      ],
      "plane_d": -2947.849609375,
      "bbox_min": [
        -3424.074951171875,
        -4942.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3374.31103515625,
        -4925.00048828125,
        1109.037841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1086.70703125,
      "bbox_min": [
        -3424.074951171875,
        -4942.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3374.31103515625,
        -4925.00048828125,
        1109.037841796875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.6401844024658203,
        0.768221378326416
      ],
      "plane_d": -3994.7822265625,
      "bbox_min": [
        -3405.78125,
        -4942.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3394.21875,
        -4925.00048828125,
        1086.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4925.00048828125,
      "bbox_min": [
        -3405.78125,
        -4925.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3394.21875,
        -4925.00048828125,
        1086.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3395.0,
      "bbox_min": [
        -3405.0,
        -4942.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3395.0,
        -4936.00048828125,
        1086.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3405.0,
      "bbox_min": [
        -3405.0,
        -4942.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3405.0,
        -4936.00048828125,
        1086.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25255274772644043,
        -0.21876409649848938,
        -0.942528247833252
      ],
      "plane_d": 822.8465576171875,
      "bbox_min": [
        -3424.074951171875,
        -4942.00048828125,
        1086.70703125
      ],
      "bbox_max": [
        -3376.3310546875,
        -4925.00048828125,
        1109.037841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25255244970321655,
        -0.21876883506774902,
        -0.9425271153450012
      ],
      "plane_d": -894.535888671875,
      "bbox_min": [
        -3424.074951171875,
        -4942.00048828125,
        1086.70703125
      ],
      "bbox_max": [
        -3376.3310546875,
        -4925.00048828125,
        1109.037841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.689979612827301,
        -0.21876069903373718,
        -0.689979612827301
      ],
      "plane_d": -2654.930419921875,
      "bbox_min": [
        -3424.074951171875,
        -4942.00048828125,
        1086.70703125
      ],
      "bbox_max": [
        -3376.3310546875,
        -4925.00048828125,
        1105.3760986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6899776458740234,
        -0.2187732309103012,
        -0.6899776458740234
      ],
      "plane_d": 2036.860107421875,
      "bbox_min": [
        -3424.074951171875,
        -4942.00048828125,
        1086.70703125
      ],
      "bbox_max": [
        -3382.0,
        -4925.00048828125,
        1105.3760986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5836361050605774,
        0.8120154142379761
      ],
      "plane_d": 1997.2379150390625,
      "bbox_min": [
        -3424.074951171875,
        -4942.00048828125,
        1086.70703125
      ],
      "bbox_max": [
        -3382.0,
        -4925.00048828125,
        1095.3724365234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3412.0,
      "bbox_min": [
        -3418.0,
        -4942.00048828125,
        1086.70703125
      ],
      "bbox_max": [
        -3382.0,
        -4934.00048828125,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3418.0,
      "bbox_min": [
        -3418.0,
        -4942.00048828125,
        1086.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4934.00048828125,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3382.0,
      "bbox_min": [
        -3388.0,
        -4942.00048828125,
        1086.70703125
      ],
      "bbox_max": [
        -3382.0,
        -4934.00048828125,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3388.0,
      "bbox_min": [
        -3388.0,
        -4942.00048828125,
        1086.70703125
      ],
      "bbox_max": [
        -3388.0,
        -4934.00048828125,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -4925.0,
      "bbox_min": [
        -3424.074951171875,
        -4942.00048828125,
        1086.70703125
      ],
      "bbox_max": [
        -3395.880859375,
        -4925.00048828125,
        1095.3724365234375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9425271153450012,
        -0.21876883506774902,
        -0.25255244970321655
      ],
      "plane_d": 2422.38427734375,
      "bbox_min": [
        -3424.074951171875,
        -4942.00048828125,
        1093.4639892578125
      ],
      "bbox_max": [
        -3423.40771484375,
        -4940.70068359375,
        1095.3724365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6899776458740234,
        -0.2187732309103012,
        -0.6899776458740234
      ],
      "plane_d": 2036.860107421875,
      "bbox_min": [
        -3424.953125,
        -4949.41015625,
        1091.70703125
      ],
      "bbox_max": [
        -3382.0,
        -4942.00048828125,
        1109.1055908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25255244970321655,
        -0.21876883506774902,
        -0.9425271153450012
      ],
      "plane_d": -894.535888671875,
      "bbox_min": [
        -3424.953125,
        -4949.41015625,
        1091.70703125
      ],
      "bbox_max": [
        -3382.0,
        -4942.00048828125,
        1109.1055908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25255274772644043,
        -0.21876409649848938,
        -0.942528247833252
      ],
      "plane_d": 822.8465576171875,
      "bbox_min": [
        -3424.953125,
        -4949.41015625,
        1091.70703125
      ],
      "bbox_max": [
        -3382.0,
        -4942.00048828125,
        1109.1055908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1091.70703125,
      "bbox_min": [
        -3424.953125,
        -4949.41015625,
        1091.70703125
      ],
      "bbox_max": [
        -3382.0,
        -4942.00048828125,
        1096.0272216796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1092.45703125,
      "bbox_min": [
        -3424.953125,
        -4949.40966796875,
        1091.70703125
      ],
      "bbox_max": [
        -3382.0,
        -4942.00048828125,
        1096.0272216796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3412.0,
      "bbox_min": [
        -3418.0,
        -4949.40966796875,
        1091.70703125
      ],
      "bbox_max": [
        -3382.0,
        -4942.00048828125,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3418.0,
      "bbox_min": [
        -3418.0,
        -4949.40966796875,
        1091.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4942.00048828125,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3382.0,
      "bbox_min": [
        -3388.0,
        -4949.40966796875,
        1091.70703125
      ],
      "bbox_max": [
        -3382.0,
        -4942.00048828125,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3388.0,
      "bbox_min": [
        -3388.0,
        -4949.40966796875,
        1091.70703125
      ],
      "bbox_max": [
        -3388.0,
        -4942.00048828125,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9425271153450012,
        -0.21876883506774902,
        -0.25255244970321655
      ],
      "plane_d": 2422.38427734375,
      "bbox_min": [
        -3424.953125,
        -4947.81201171875,
        1093.8568115234375
      ],
      "bbox_max": [
        -3423.6689453125,
        -4942.00048828125,
        1096.0272216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1088.70703125,
      "bbox_min": [
        -3425.66015625,
        -5064.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4942.29248046875,
        1111.70703125
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3409.0,
      "bbox_min": [
        -3425.66015625,
        -5043.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3371.875732421875,
        -4942.29248046875,
        1111.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1090.70703125,
      "bbox_min": [
        -3425.66015625,
        -5043.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4943.193359375,
        1109.2955322265625
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3413.0,
      "bbox_min": [
        -3422.5,
        -5043.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4952.7861328125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9743912220001221,
        0.22485950589179993,
        -0.0
      ],
      "plane_d": 4445.7724609375,
      "bbox_min": [
        -3413.0,
        -5042.58642578125,
        1088.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4952.7861328125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827044665813446,
        0.9238708019256592,
        0.0
      ],
      "plane_d": 3348.83203125,
      "bbox_min": [
        -3413.0,
        -5042.58642578125,
        1088.70703125
      ],
      "bbox_max": [
        -3409.0,
        -5030.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826840817928314,
        -0.9238792657852173,
        0.0
      ],
      "plane_d": -3352.64013671875,
      "bbox_min": [
        -3413.0,
        -5042.58642578125,
        1088.70703125
      ],
      "bbox_max": [
        -3409.0,
        -5040.92919921875,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238940477371216,
        -0.3826485574245453,
        0.0
      ],
      "plane_d": 1224.8323974609375,
      "bbox_min": [
        -3413.0,
        -5034.58642578125,
        1088.70703125
      ],
      "bbox_max": [
        -3409.0,
        -5030.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826485574245453,
        -0.9238940477371216,
        0.0
      ],
      "plane_d": -3345.44482421875,
      "bbox_min": [
        -3413.0,
        -5034.58642578125,
        1088.70703125
      ],
      "bbox_max": [
        -3410.46435546875,
        -5033.5361328125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3412.0,
      "bbox_min": [
        -3413.0,
        -4986.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4952.7861328125,
        1090.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 2743.781982421875,
      "bbox_min": [
        -3413.0,
        -4971.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3412.0,
        -4969.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.13865022361278534,
        -0.9903414249420166
      ],
      "plane_d": 392.9722900390625,
      "bbox_min": [
        -3412.0,
        -4956.35791015625,
        1090.3070068359375
      ],
      "bbox_max": [
        -3409.0,
        -4952.7861328125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4886098802089691,
        -0.8725023865699768
      ],
      "plane_d": 3371.62451171875,
      "bbox_min": [
        -3412.0,
        -4953.50048828125,
        1090.3070068359375
      ],
      "bbox_max": [
        -3409.0,
        -4952.7861328125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9743912220001221,
        -0.22485950589179993,
        -0.0
      ],
      "plane_d": -4449.669921875,
      "bbox_min": [
        -3422.5,
        -5043.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3413.0,
        -4969.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3416.0,
      "bbox_min": [
        -3416.0,
        -4986.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3413.0,
        -4969.00048828125,
        1090.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 2743.781982421875,
      "bbox_min": [
        -3416.0,
        -4971.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3413.0,
        -4969.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5035.00048828125,
      "bbox_min": [
        -3422.5,
        -5043.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3413.0,
        -5030.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5031.00048828125,
      "bbox_min": [
        -3422.5,
        -5035.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3413.0,
        -5030.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826485574245453,
        -0.9238940477371216,
        0.0
      ],
      "plane_d": -3345.44482421875,
      "bbox_min": [
        -3414.0,
        -5035.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3413.0,
        -5034.58642578125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3828025758266449,
        0.9238302111625671,
        0.0
      ],
      "plane_d": 3340.902099609375,
      "bbox_min": [
        -3414.0,
        -5031.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3413.0,
        -5030.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238302111625671,
        0.3828025758266449,
        0.0
      ],
      "plane_d": -1227.535400390625,
      "bbox_min": [
        -3413.29296875,
        -5030.70751953125,
        1088.70703125
      ],
      "bbox_max": [
        -3413.0,
        -5030.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5039.00048828125,
      "bbox_min": [
        -3422.5,
        -5043.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3413.0,
        -5038.58642578125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5043.00048828125,
      "bbox_min": [
        -3422.5,
        -5043.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3413.0,
        -5042.58642578125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826840817928314,
        -0.9238792657852173,
        0.0
      ],
      "plane_d": -3352.64013671875,
      "bbox_min": [
        -3414.0,
        -5043.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3413.0,
        -5042.58642578125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827044665813446,
        0.9238708019256592,
        0.0
      ],
      "plane_d": 3348.83203125,
      "bbox_min": [
        -3414.0,
        -5039.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3413.0,
        -5038.58642578125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1091.7069091796875,
      "bbox_min": [
        -3425.66015625,
        -5043.00048828125,
        1090.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4943.193359375,
        1109.2955322265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6899776458740234,
        -0.2187732309103012,
        -0.6899776458740234
      ],
      "plane_d": 2036.860107421875,
      "bbox_min": [
        -3425.66015625,
        -5043.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4943.193359375,
        1109.2955322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3412.0,
      "bbox_min": [
        -3425.66015625,
        -5043.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4943.193359375,
        1109.2955322265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4953.50048828125,
      "bbox_min": [
        -3412.0,
        -4969.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4943.193359375,
        1109.2955322265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4951.0,
      "bbox_min": [
        -3412.0,
        -4953.50048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4943.193359375,
        1109.29541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25255274772644043,
        -0.21876409649848938,
        -0.942528247833252
      ],
      "plane_d": 822.8465576171875,
      "bbox_min": [
        -3412.0,
        -4953.50048828125,
        1107.911376953125
      ],
      "bbox_max": [
        -3409.0,
        -4951.00048828125,
        1109.29541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25255274772644043,
        -0.21876409649848938,
        -0.942528247833252
      ],
      "plane_d": 822.8465576171875,
      "bbox_min": [
        -3412.0,
        -4951.00048828125,
        1106.1690673828125
      ],
      "bbox_max": [
        -3409.0,
        -4943.193359375,
        1108.7152099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1092.45703125,
      "bbox_min": [
        -3412.0,
        -4969.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4953.50048828125,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4969.00048828125,
      "bbox_min": [
        -3412.0,
        -4969.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4969.00048828125,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1092.4569091796875,
      "bbox_min": [
        -3425.66015625,
        -5043.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3412.0,
        -4943.49365234375,
        1108.4915771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3418.0,
      "bbox_min": [
        -3418.0,
        -4969.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3412.0,
        -4949.10302734375,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -5926.2626953125,
      "bbox_min": [
        -3418.0,
        -4969.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3412.0,
        -4963.00048828125,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25255274772644043,
        -0.21876409649848938,
        -0.942528247833252
      ],
      "plane_d": 822.8465576171875,
      "bbox_min": [
        -3425.66015625,
        -5043.00048828125,
        1093.706787109375
      ],
      "bbox_max": [
        -3412.0,
        -4943.49365234375,
        1108.4915771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3424.0,
      "bbox_min": [
        -3425.66015625,
        -5043.00048828125,
        1093.706787109375
      ],
      "bbox_max": [
        -3424.0,
        -4947.642578125,
        1098.687744140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5035.00048828125,
      "bbox_min": [
        -3425.66015625,
        -5043.00048828125,
        1093.706787109375
      ],
      "bbox_max": [
        -3424.0,
        -4947.642578125,
        1098.687744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5031.00048828125,
      "bbox_min": [
        -3425.66015625,
        -5031.00048828125,
        1093.706787109375
      ],
      "bbox_max": [
        -3424.0,
        -4947.642578125,
        1098.687744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9425271153450012,
        -0.21876883506774902,
        -0.25255244970321655
      ],
      "plane_d": 2422.38427734375,
      "bbox_min": [
        -3425.304931640625,
        -4950.13916015625,
        1095.6134033203125
      ],
      "bbox_max": [
        -3424.80322265625,
        -4947.642578125,
        1096.31689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5043.00048828125,
      "bbox_min": [
        -3425.66015625,
        -5043.00048828125,
        1093.706787109375
      ],
      "bbox_max": [
        -3424.0,
        -5043.00048828125,
        1098.687744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3412.0,
      "bbox_min": [
        -3412.0,
        -4963.50048828125,
        1090.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4951.00048828125,
        1091.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.4886098802089691,
        -0.8725023865699768
      ],
      "plane_d": 3371.62451171875,
      "bbox_min": [
        -3412.0,
        -4952.7861328125,
        1090.70703125
      ],
      "bbox_max": [
        -3409.0,
        -4951.00048828125,
        1091.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1090.70703125,
      "bbox_min": [
        -3409.0,
        -5040.92919921875,
        1088.70703125
      ],
      "bbox_max": [
        -3371.875732421875,
        -4942.29248046875,
        1111.70703125
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3401.0,
      "bbox_min": [
        -3409.0,
        -5040.92919921875,
        1088.70703125
      ],
      "bbox_max": [
        -3371.875732421875,
        -4949.81884765625,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3405.0,
      "bbox_min": [
        -3409.0,
        -5040.92919921875,
        1088.70703125
      ],
      "bbox_max": [
        -3401.0,
        -4969.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9743912220001221,
        0.22485950589179993,
        -0.0
      ],
      "plane_d": 4437.9775390625,
      "bbox_min": [
        -3405.0,
        -5039.2724609375,
        1088.70703125
      ],
      "bbox_max": [
        -3401.0,
        -4969.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792657852173,
        -0.3826840817928314,
        0.0
      ],
      "plane_d": 1217.212158203125,
      "bbox_min": [
        -3405.0,
        -5039.2724609375,
        1088.70703125
      ],
      "bbox_max": [
        -3401.0,
        -5030.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826840817928314,
        -0.9238792657852173,
        0.0
      ],
      "plane_d": -3352.64013671875,
      "bbox_min": [
        -3405.0,
        -5039.2724609375,
        1088.70703125
      ],
      "bbox_max": [
        -3404.8076171875,
        -5039.19287109375,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3404.0,
      "bbox_min": [
        -3405.0,
        -4986.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4969.00048828125,
        1090.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 2743.781982421875,
      "bbox_min": [
        -3405.0,
        -4971.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4969.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9743912220001221,
        -0.22485950589179993,
        -0.0
      ],
      "plane_d": -4441.875,
      "bbox_min": [
        -3409.0,
        -5040.92919921875,
        1088.70703125
      ],
      "bbox_max": [
        -3405.0,
        -4969.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3408.0,
      "bbox_min": [
        -3408.0,
        -4986.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3405.0,
        -4969.00048828125,
        1090.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 2743.781982421875,
      "bbox_min": [
        -3408.0,
        -4971.00048828125,
        1088.70703125
      ],
      "bbox_max": [
        -3405.0,
        -4969.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238782525062561,
        0.3826867938041687,
        0.0
      ],
      "plane_d": -1220.890625,
      "bbox_min": [
        -3409.0,
        -5040.92919921875,
        1088.70703125
      ],
      "bbox_max": [
        -3405.0,
        -5030.00048828125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826840817928314,
        -0.9238792657852173,
        0.0
      ],
      "plane_d": -3352.64013671875,
      "bbox_min": [
        -3409.0,
        -5040.92919921875,
        1088.70703125
      ],
      "bbox_max": [
        -3405.0,
        -5039.2724609375,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3827044665813446,
        0.9238708019256592,
        0.0
      ],
      "plane_d": 3348.83203125,
      "bbox_min": [
        -3409.0,
        -5036.92919921875,
        1088.70703125
      ],
      "bbox_max": [
        -3407.635986328125,
        -5036.3642578125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9425258040428162,
        -0.2187749594449997,
        -0.2525521218776703
      ],
      "plane_d": -3986.826416015625,
      "bbox_min": [
        -3391.0,
        -4956.35791015625,
        1088.70703125
      ],
      "bbox_max": [
        -3371.875732421875,
        -4949.81884765625,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.13865022361278534,
        -0.9903414249420166
      ],
      "plane_d": 392.9722900390625,
      "bbox_min": [
        -3391.0,
        -4956.35791015625,
        1090.3070068359375
      ],
      "bbox_max": [
        -3388.0,
        -4952.7861328125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4886098802089691,
        -0.8725023865699768
      ],
      "plane_d": 3371.62451171875,
      "bbox_min": [
        -3391.0,
        -4956.35791015625,
        1090.3070068359375
      ],
      "bbox_max": [
        -3388.0,
        -4952.7861328125,
        1090.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3388.0,
      "bbox_min": [
        -3391.0,
        -4956.35791015625,
        1090.3070068359375
      ],
      "bbox_max": [
        -3388.0,
        -4952.7861328125,
        1090.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3391.0,
      "bbox_min": [
        -3391.0,
        -4956.35791015625,
        1090.3070068359375
      ],
      "bbox_max": [
        -3391.0,
        -4952.7861328125,
        1090.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1091.70703125,
      "bbox_min": [
        -3409.0,
        -4969.00048828125,
        1090.70703125
      ],
      "bbox_max": [
        -3372.41162109375,
        -4942.29248046875,
        1111.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4969.00048828125,
      "bbox_min": [
        -3409.0,
        -4969.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3372.6796875,
        -4942.29248046875,
        1111.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4953.50048828125,
      "bbox_min": [
        -3409.0,
        -4969.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3372.6796875,
        -4942.29248046875,
        1111.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1092.45703125,
      "bbox_min": [
        -3409.0,
        -4969.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3382.0,
        -4953.50048828125,
        1103.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3382.0,
      "bbox_min": [
        -3388.0,
        -4969.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3382.0,
        -4953.50048828125,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1117.936279296875,
      "bbox_min": [
        -3388.0,
        -4969.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3382.0,
        -4963.00048828125,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1096.7069091796875,
      "bbox_min": [
        -3409.0,
        -4969.00048828125,
        1092.45703125
      ],
      "bbox_max": [
        -3391.0,
        -4965.00048828125,
        1103.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9734172224998474,
        0.22903934121131897
      ],
      "plane_d": -5087.12646484375,
      "bbox_min": [
        -3409.0,
        -4969.00048828125,
        1092.45703125
      ],
      "bbox_max": [
        -3391.0,
        -4965.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.00048828125,
      "bbox_min": [
        -3409.0,
        -4969.00048828125,
        1092.45703125
      ],
      "bbox_max": [
        -3391.0,
        -4965.00048828125,
        1096.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.1960700899362564,
        0.9805898666381836
      ],
      "plane_d": -100.2647705078125,
      "bbox_min": [
        -3408.0,
        -4969.00048828125,
        1092.45703125
      ],
      "bbox_max": [
        -3391.0,
        -4965.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4967.00048828125,
      "bbox_min": [
        -3408.0,
        -4969.00048828125,
        1092.45703125
      ],
      "bbox_max": [
        -3391.0,
        -4965.00048828125,
        1095.6563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3391.0,
      "bbox_min": [
        -3391.0,
        -4969.00048828125,
        1092.45703125
      ],
      "bbox_max": [
        -3391.0,
        -4967.00048828125,
        1095.6563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1094.8070068359375,
      "bbox_min": [
        -3408.0,
        -4967.00048828125,
        1092.45703125
      ],
      "bbox_max": [
        -3391.0,
        -4965.00048828125,
        1095.406982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3391.0,
      "bbox_min": [
        -3391.0,
        -4967.00048828125,
        1094.8070068359375
      ],
      "bbox_max": [
        -3391.0,
        -4965.00048828125,
        1095.406982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3392.0,
      "bbox_min": [
        -3408.0,
        -4967.00048828125,
        1092.45703125
      ],
      "bbox_max": [
        -3391.0,
        -4965.00048828125,
        1094.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3391.0,
      "bbox_min": [
        -3391.0,
        -4967.00048828125,
        1092.45703125
      ],
      "bbox_max": [
        -3391.0,
        -4965.00048828125,
        1094.8070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3392.0,
      "bbox_min": [
        -3408.0,
        -4967.00048828125,
        1095.007080078125
      ],
      "bbox_max": [
        -3391.0,
        -4965.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3391.0,
      "bbox_min": [
        -3391.0,
        -4967.00048828125,
        1095.007080078125
      ],
      "bbox_max": [
        -3391.0,
        -4965.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3408.0,
      "bbox_min": [
        -3408.0,
        -4967.00048828125,
        1095.007080078125
      ],
      "bbox_max": [
        -3408.0,
        -4965.00048828125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4967.400390625,
      "bbox_min": [
        -3408.0,
        -4967.400390625,
        1096.70703125
      ],
      "bbox_max": [
        -3392.0,
        -4967.400390625,
        1103.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25255244970321655,
        -0.21876883506774902,
        -0.9425271153450012
      ],
      "plane_d": -894.535888671875,
      "bbox_min": [
        -3409.0,
        -4953.50048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3372.6796875,
        -4942.29248046875,
        1111.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -3391.0,
      "bbox_min": [
        -3409.0,
        -4953.50048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3372.6796875,
        -4942.29248046875,
        1111.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3388.0,
      "bbox_min": [
        -3391.0,
        -4953.50048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3372.6796875,
        -4947.642578125,
        1108.7152099609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4951.00048828125,
      "bbox_min": [
        -3391.0,
        -4951.00048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3388.0,
        -4951.00048828125,
        1108.7152099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9425258040428162,
        -0.2187749594449997,
        -0.2525521218776703
      ],
      "plane_d": -3986.826416015625,
      "bbox_min": [
        -3388.0,
        -4953.50048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3372.6796875,
        -4947.642578125,
        1096.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3382.0,
      "bbox_min": [
        -3382.0,
        -4953.50048828125,
        1091.70703125
      ],
      "bbox_max": [
        -3382.0,
        -4949.10302734375,
        1092.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25255274772644043,
        -0.21876409649848938,
        -0.942528247833252
      ],
      "plane_d": 822.8465576171875,
      "bbox_min": [
        -3409.0,
        -4953.50048828125,
        1106.9031982421875
      ],
      "bbox_max": [
        -3400.0,
        -4942.29248046875,
        1111.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3388.0,
      "bbox_min": [
        -3391.0,
        -4963.50048828125,
        1090.70703125
      ],
      "bbox_max": [
        -3372.41162109375,
        -4949.40966796875,
        1091.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3391.0,
      "bbox_min": [
        -3391.0,
        -4963.50048828125,
        1090.70703125
      ],
      "bbox_max": [
        -3388.0,
        -4951.00048828125,
        1091.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.4886098802089691,
        -0.8725023865699768
      ],
      "plane_d": 3371.62451171875,
      "bbox_min": [
        -3391.0,
        -4952.7861328125,
        1090.70703125
      ],
      "bbox_max": [
        -3388.0,
        -4951.00048828125,
        1091.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9425258040428162,
        -0.2187749594449997,
        -0.2525521218776703
      ],
      "plane_d": -3986.826416015625,
      "bbox_min": [
        -3373.62890625,
        -4953.50048828125,
        1090.70703125
      ],
      "bbox_max": [
        -3372.41162109375,
        -4949.40966796875,
        1091.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9179146885871887,
        -0.15040530264377594,
        0.36716586351394653
      ],
      "plane_d": -4245.66162109375,
      "bbox_min": [
        -3420.0,
        -5064.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4950.63720703125,
        1088.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3378.0,
      "bbox_min": [
        -3379.63623046875,
        -4971.76513671875,
        1081.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4950.63720703125,
        1088.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6792625188827515,
        -0.6792625188827515,
        0.2778575122356415
      ],
      "plane_d": -5960.94775390625,
      "bbox_min": [
        -3379.63623046875,
        -4953.50048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4951.8642578125,
        1085.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 5891.2607421875,
      "bbox_min": [
        -3379.63623046875,
        -4953.50048828125,
        1083.6845703125
      ],
      "bbox_max": [
        -3378.0,
        -4951.8642578125,
        1085.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9425258040428162,
        -0.2187749594449997,
        -0.2525521218776703
      ],
      "plane_d": -3986.826416015625,
      "bbox_min": [
        -3372.540283203125,
        -4953.50048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4950.63720703125,
        1088.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4971.00048828125,
      "bbox_min": [
        -3420.0,
        -5064.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4951.8642578125,
        1088.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4969.00048828125,
      "bbox_min": [
        -3420.0,
        -4971.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4951.8642578125,
        1088.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3412.0,
      "bbox_min": [
        -3416.0,
        -4971.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4969.00048828125,
        1088.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3416.0,
      "bbox_min": [
        -3416.0,
        -4971.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3416.0,
        -4969.00048828125,
        1088.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3404.0,
      "bbox_min": [
        -3408.0,
        -4971.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4969.00048828125,
        1088.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3408.0,
      "bbox_min": [
        -3408.0,
        -4971.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3408.0,
        -4969.00048828125,
        1088.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037883758544922,
        -0.7378033995628357,
        0.3018041253089905
      ],
      "plane_d": -1917.424560546875,
      "bbox_min": [
        -3420.0,
        -4953.5009765625,
        1081.70703125
      ],
      "bbox_max": [
        -3418.0,
        -4951.8642578125,
        1085.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.38267579674720764,
        0.923882782459259
      ],
      "plane_d": 936.652099609375,
      "bbox_min": [
        -3405.0,
        -5064.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5059.171875,
        1083.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3403.0,
      "bbox_min": [
        -3405.0,
        -5064.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5059.171875,
        1083.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4957.00048828125,
      "bbox_min": [
        -3430.0,
        -4959.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1078.70703125,
      "bbox_min": [
        -3430.0,
        -4959.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4957.00048828125,
        1079.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1075.70703125,
      "bbox_min": [
        -3430.0,
        -4959.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4957.00048828125,
        1075.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162277936935425,
        0.0,
        -0.9486833810806274
      ],
      "plane_d": -43.6011962890625,
      "bbox_min": [
        -3377.0,
        -4959.00048828125,
        1078.70703125
      ],
      "bbox_max": [
        -3374.0,
        -4957.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4925.00048828125,
      "bbox_min": [
        -3430.0,
        -4957.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7766754627227783,
        -0.629901111125946,
        0.0
      ],
      "plane_d": -450.46337890625,
      "bbox_min": [
        -3430.0,
        -4957.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7766754627227783,
        -0.629901111125946,
        -0.0
      ],
      "plane_d": -5731.8564453125,
      "bbox_min": [
        -3430.0,
        -4957.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4118106961250305,
        -0.9112694263458252,
        -0.0
      ],
      "plane_d": -5885.40966796875,
      "bbox_min": [
        -3430.0,
        -4957.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4118106961250305,
        -0.9112694263458252,
        0.0
      ],
      "plane_d": -3085.096923828125,
      "bbox_min": [
        -3430.0,
        -4957.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9741045236587524,
        -0.2260982245206833,
        0.0
      ],
      "plane_d": 2221.20068359375,
      "bbox_min": [
        -3430.0,
        -4957.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4940.70068359375,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9741045236587524,
        -0.2260982245206833,
        -0.0
      ],
      "plane_d": -4402.7099609375,
      "bbox_min": [
        -3412.0,
        -4957.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4940.70068359375,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 4265.4150390625,
      "bbox_min": [
        -3370.232177734375,
        -4953.50048828125,
        1078.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4952.50048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3396.0,
      "bbox_min": [
        -3412.0,
        -4957.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4945.00048828125,
        1079.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4945.00048828125,
      "bbox_min": [
        -3396.0,
        -4957.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4945.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3392.0,
      "bbox_min": [
        -3396.0,
        -4957.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4945.00048828125,
        1079.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4948.00048828125,
      "bbox_min": [
        -3396.0,
        -4957.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3392.0,
        -4945.00048828125,
        1078.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7682245373725891,
        0.6401805877685547
      ],
      "plane_d": 3112.78466796875,
      "bbox_min": [
        -3396.0,
        -4948.00048828125,
        1071.70703125
      ],
      "bbox_max": [
        -3392.0,
        -4945.00048828125,
        1074.5670166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4179037809371948,
        0.908491313457489
      ],
      "plane_d": 1091.5533447265625,
      "bbox_min": [
        -3396.0,
        -4948.00048828125,
        1074.1070556640625
      ],
      "bbox_max": [
        -3392.0,
        -4947.00048828125,
        1074.5670166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4179037809371948,
        0.908491313457489
      ],
      "plane_d": 1091.5533447265625,
      "bbox_min": [
        -3396.0,
        -4957.00048828125,
        1071.70703125
      ],
      "bbox_max": [
        -3392.0,
        -4948.00048828125,
        1078.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.40613850951194763,
        -0.9138116240501404
      ],
      "plane_d": -1030.235107421875,
      "bbox_min": [
        -3396.0,
        -4957.00048828125,
        1071.70703125
      ],
      "bbox_max": [
        -3392.0,
        -4948.00048828125,
        1075.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1078.70703125,
      "bbox_min": [
        -3377.0,
        -4957.00048828125,
        1078.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4952.50048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162277936935425,
        0.0,
        -0.9486833810806274
      ],
      "plane_d": -43.6011962890625,
      "bbox_min": [
        -3377.0,
        -4957.00048828125,
        1078.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4952.50048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 4265.4150390625,
      "bbox_min": [
        -3377.0,
        -4953.50048828125,
        1078.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4952.50048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22941572964191437,
        0.6882471442222595,
        -0.6882471442222595
      ],
      "plane_d": 3377.60107421875,
      "bbox_min": [
        -3377.0,
        -4953.50048828125,
        1078.70703125
      ],
      "bbox_max": [
        -3374.0,
        -4952.50048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4945.00048828125,
      "bbox_min": [
        -3412.0,
        -4957.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3408.0,
        -4945.00048828125,
        1078.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3408.0,
      "bbox_min": [
        -3412.0,
        -4957.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3408.0,
        -4945.00048828125,
        1078.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3412.0,
      "bbox_min": [
        -3412.0,
        -4957.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3408.0,
        -4945.00048828125,
        1078.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4948.00048828125,
      "bbox_min": [
        -3412.0,
        -4957.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3408.0,
        -4945.00048828125,
        1078.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7682245373725891,
        0.6401805877685547
      ],
      "plane_d": 3112.78466796875,
      "bbox_min": [
        -3412.0,
        -4948.00048828125,
        1071.70703125
      ],
      "bbox_max": [
        -3408.0,
        -4945.00048828125,
        1074.5670166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4179037809371948,
        0.908491313457489
      ],
      "plane_d": 1091.5533447265625,
      "bbox_min": [
        -3412.0,
        -4948.00048828125,
        1074.1070556640625
      ],
      "bbox_max": [
        -3408.0,
        -4947.00048828125,
        1074.5670166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4179037809371948,
        0.908491313457489
      ],
      "plane_d": 1091.5533447265625,
      "bbox_min": [
        -3412.0,
        -4957.00048828125,
        1071.70703125
      ],
      "bbox_max": [
        -3408.0,
        -4948.00048828125,
        1078.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.40613850951194763,
        -0.9138116240501404
      ],
      "plane_d": -1030.235107421875,
      "bbox_min": [
        -3412.0,
        -4957.00048828125,
        1071.70703125
      ],
      "bbox_max": [
        -3408.0,
        -4948.00048828125,
        1075.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5064.00048828125,
      "bbox_min": [
        -3430.0,
        -5095.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5081.00048828125,
      "bbox_min": [
        -3397.0,
        -5095.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5064.00048828125,
        1079.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3380.0,
      "bbox_min": [
        -3380.0,
        -5095.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5081.00048828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.39391934871673584,
        -0.9191451072692871
      ],
      "plane_d": 2992.073486328125,
      "bbox_min": [
        -3380.0,
        -5095.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5081.00048828125,
        1077.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1061.70703125,
      "bbox_min": [
        -3380.0,
        -5095.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5081.00048828125,
        1071.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5095.00048828125,
      "bbox_min": [
        -3380.0,
        -5095.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5095.00048828125,
        1071.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1061.70703125,
      "bbox_min": [
        -3397.0,
        -5081.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5064.00048828125,
        1079.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 5993.4375,
      "bbox_min": [
        -3397.0,
        -5081.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5064.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3397.0,
      "bbox_min": [
        -3397.0,
        -5081.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5064.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3380.0,
      "bbox_min": [
        -3397.0,
        -5081.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5064.00048828125,
        1079.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.9858424067497253,
        -0.1676744967699051
      ],
      "plane_d": -4814.28564453125,
      "bbox_min": [
        -3397.0,
        -5081.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5064.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8683075308799744,
        -0.4960263669490814
      ],
      "plane_d": -3867.80908203125,
      "bbox_min": [
        -3397.0,
        -5081.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5064.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6157490611076355,
        -0.7879424095153809
      ],
      "plane_d": -2273.5302734375,
      "bbox_min": [
        -3397.0,
        -5081.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5064.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": 1649.88720703125,
      "bbox_min": [
        -3397.0,
        -5081.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3395.0,
        -5064.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070826888084412,
        -0.6140070557594299,
        -0.3507555425167084
      ],
      "plane_d": -334.50146484375,
      "bbox_min": [
        -3397.0,
        -5079.41796875,
        1061.70703125
      ],
      "bbox_max": [
        -3395.0,
        -5064.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070659399032593,
        -0.6971361041069031,
        -0.11857061088085175
      ],
      "plane_d": -1003.921630859375,
      "bbox_min": [
        -3397.0,
        -5079.41796875,
        1061.70703125
      ],
      "bbox_max": [
        -3395.0,
        -5064.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071056365966797,
        -0.43540096282958984,
        -0.5571601986885071
      ],
      "plane_d": 792.99267578125,
      "bbox_min": [
        -3397.0,
        -5079.41796875,
        1064.906982421875
      ],
      "bbox_max": [
        -3395.0,
        -5069.0087890625,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070902585983276,
        -0.16259263455867767,
        -0.688176691532135
      ],
      "plane_d": 2318.84375,
      "bbox_min": [
        -3397.0,
        -5079.41796875,
        1064.906982421875
      ],
      "bbox_max": [
        -3395.517578125,
        -5073.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3396.60009765625,
      "bbox_min": [
        -3397.0,
        -5076.1005859375,
        1064.906982421875
      ],
      "bbox_max": [
        -3396.60009765625,
        -5073.00048828125,
        1066.906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1066.906982421875,
      "bbox_min": [
        -3397.0,
        -5076.1005859375,
        1064.906982421875
      ],
      "bbox_max": [
        -3396.60009765625,
        -5073.00048828125,
        1066.906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.906982421875,
      "bbox_min": [
        -3397.0,
        -5076.1005859375,
        1064.906982421875
      ],
      "bbox_max": [
        -3396.60009765625,
        -5073.00048828125,
        1066.906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5073.00048828125,
      "bbox_min": [
        -3397.0,
        -5076.1005859375,
        1064.906982421875
      ],
      "bbox_max": [
        -3396.60009765625,
        -5073.00048828125,
        1066.906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5076.1005859375,
      "bbox_min": [
        -3397.0,
        -5076.1005859375,
        1064.906982421875
      ],
      "bbox_max": [
        -3396.60009765625,
        -5076.1005859375,
        1066.906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3403.0,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1073.70703125,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1070.7069091796875,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4999.00048828125,
        1073.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3405.0,
      "bbox_min": [
        -3430.0,
        -5056.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4999.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5056.00048828125,
      "bbox_min": [
        -3405.0,
        -5056.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4999.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4999.00048828125,
      "bbox_min": [
        -3405.0,
        -4999.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4999.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5056.00048828125,
      "bbox_min": [
        -3430.0,
        -5056.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3405.0,
        -4999.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4999.00048828125,
      "bbox_min": [
        -3430.0,
        -5056.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3405.0,
        -4999.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3427.0,
      "bbox_min": [
        -3430.0,
        -5056.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3405.0,
        -5001.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5023.00048828125,
      "bbox_min": [
        -3430.0,
        -5023.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3427.0,
        -5023.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5001.00048828125,
      "bbox_min": [
        -3427.0,
        -5056.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3405.0,
        -5001.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3420.0,
      "bbox_min": [
        -3422.0,
        -5056.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3420.0,
        -5054.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5054.00048828125,
      "bbox_min": [
        -3422.0,
        -5056.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3420.0,
        -5054.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3422.0,
      "bbox_min": [
        -3422.0,
        -5056.00048828125,
        1070.70703125
      ],
      "bbox_max": [
        -3422.0,
        -5054.00048828125,
        1073.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38268932700157166,
        -0.9238771796226501
      ],
      "plane_d": 2920.673583984375,
      "bbox_min": [
        -3430.0,
        -5064.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5054.00048828125,
        1070.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8932863473892212,
        -0.44948819279670715
      ],
      "plane_d": 4997.72607421875,
      "bbox_min": [
        -3430.0,
        -5058.34375,
        1066.0501708984375
      ],
      "bbox_max": [
        -3403.0,
        -5054.00048828125,
        1070.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3420.0,
      "bbox_min": [
        -3422.0,
        -5058.34375,
        1066.0501708984375
      ],
      "bbox_max": [
        -3403.0,
        -5054.00048828125,
        1070.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3422.0,
      "bbox_min": [
        -3422.0,
        -5058.34375,
        1066.0501708984375
      ],
      "bbox_max": [
        -3420.0,
        -5054.00048828125,
        1070.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.900675892829895,
        -0.4344918429851532
      ],
      "plane_d": 5017.22998046875,
      "bbox_min": [
        -3422.0,
        -5055.7236328125,
        1067.135498046875
      ],
      "bbox_max": [
        -3420.0,
        -5054.00048828125,
        1070.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3405.0,
      "bbox_min": [
        -3405.0,
        -5058.34375,
        1066.0501708984375
      ],
      "bbox_max": [
        -3403.0,
        -5054.00048828125,
        1070.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.900675892829895,
        -0.4344918429851532
      ],
      "plane_d": 5017.22998046875,
      "bbox_min": [
        -3405.0,
        -5055.7236328125,
        1067.135498046875
      ],
      "bbox_max": [
        -3403.0,
        -5054.00048828125,
        1070.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38267579674720764,
        -0.923882782459259
      ],
      "plane_d": 2918.76318359375,
      "bbox_min": [
        -3422.0,
        -5064.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5055.7236328125,
        1067.135498046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3420.0,
      "bbox_min": [
        -3422.0,
        -5064.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5055.7236328125,
        1067.135498046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.900675892829895,
        -0.4344918429851532
      ],
      "plane_d": 5017.22998046875,
      "bbox_min": [
        -3422.0,
        -5056.92919921875,
        1064.635986328125
      ],
      "bbox_max": [
        -3420.0,
        -5055.7236328125,
        1067.135498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3405.0,
      "bbox_min": [
        -3405.0,
        -5064.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5055.7236328125,
        1067.135498046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.900675892829895,
        -0.4344918429851532
      ],
      "plane_d": 5017.22998046875,
      "bbox_min": [
        -3405.0,
        -5056.92919921875,
        1064.635986328125
      ],
      "bbox_max": [
        -3403.0,
        -5055.7236328125,
        1067.135498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9238730072975159,
        0.38269925117492676
      ],
      "plane_d": 4260.1953125,
      "bbox_min": [
        -3430.0,
        -5059.17236328125,
        1073.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.38268932700157166,
        0.9238771796226501
      ],
      "plane_d": 938.5745239257812,
      "bbox_min": [
        -3430.0,
        -5059.17236328125,
        1079.3638916015625
      ],
      "bbox_max": [
        -3403.0,
        -5058.34375,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3422.0,
      "bbox_min": [
        -3422.0,
        -5059.17236328125,
        1079.3638916015625
      ],
      "bbox_max": [
        -3422.0,
        -5058.34375,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3405.0,
      "bbox_min": [
        -3405.0,
        -5059.17236328125,
        1079.3638916015625
      ],
      "bbox_max": [
        -3405.0,
        -5058.34375,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3412.0,
      "bbox_min": [
        -3422.0,
        -5058.48583984375,
        1073.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3416.0,
      "bbox_min": [
        -3422.0,
        -5058.48583984375,
        1073.70703125
      ],
      "bbox_max": [
        -3412.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1078.70703125,
      "bbox_min": [
        -3416.0,
        -4971.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3412.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1075.70703125,
      "bbox_min": [
        -3416.0,
        -4971.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3412.0,
        -4959.00048828125,
        1078.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4971.00048828125,
      "bbox_min": [
        -3416.0,
        -4971.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3412.0,
        -4971.00048828125,
        1078.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4971.00048828125,
      "bbox_min": [
        -3416.0,
        -4971.00048828125,
        1078.70703125
      ],
      "bbox_max": [
        -3412.0,
        -4969.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4969.00048828125,
      "bbox_min": [
        -3416.0,
        -4969.00048828125,
        1078.70703125
      ],
      "bbox_max": [
        -3412.0,
        -4969.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9238893389701843,
        0.38265982270240784
      ],
      "plane_d": 4258.47265625,
      "bbox_min": [
        -3422.0,
        -5058.48583984375,
        1073.70703125
      ],
      "bbox_max": [
        -3420.0,
        -5054.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 3419.999755859375,
      "bbox_min": [
        -3422.0,
        -5058.48583984375,
        1073.70703125
      ],
      "bbox_max": [
        -3420.0,
        -5054.00048828125,
        1079.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3421.999755859375,
      "bbox_min": [
        -3422.0,
        -5058.48583984375,
        1073.70703125
      ],
      "bbox_max": [
        -3422.0,
        -5054.00048828125,
        1079.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3408.0,
      "bbox_min": [
        -3408.0,
        -5058.48583984375,
        1073.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3404.0,
      "bbox_min": [
        -3408.0,
        -5058.48583984375,
        1073.70703125
      ],
      "bbox_max": [
        -3403.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.9238893389701843,
        0.38265982270240784
      ],
      "plane_d": 4258.47265625,
      "bbox_min": [
        -3408.0,
        -5058.48583984375,
        1073.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3404.999755859375,
      "bbox_min": [
        -3405.0,
        -5058.48583984375,
        1073.70703125
      ],
      "bbox_max": [
        -3405.0,
        -5054.00048828125,
        1079.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1078.70703125,
      "bbox_min": [
        -3408.0,
        -4971.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1075.70703125,
      "bbox_min": [
        -3408.0,
        -4971.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4959.00048828125,
        1078.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4971.00048828125,
      "bbox_min": [
        -3408.0,
        -4971.00048828125,
        1075.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4971.00048828125,
        1078.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4971.00048828125,
      "bbox_min": [
        -3408.0,
        -4971.00048828125,
        1078.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4969.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4969.00048828125,
      "bbox_min": [
        -3408.0,
        -4969.00048828125,
        1078.70703125
      ],
      "bbox_max": [
        -3404.0,
        -4969.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9238893389701843,
        0.38265982270240784
      ],
      "plane_d": 4258.47265625,
      "bbox_min": [
        -3404.0,
        -5056.4853515625,
        1073.70703125
      ],
      "bbox_max": [
        -3403.0,
        -5054.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.294752836227417,
        0.36222636699676514,
        -0.8842583894729614
      ],
      "plane_d": 1756.72705078125,
      "bbox_min": [
        -3403.0,
        -5064.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4959.5595703125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.37906694412231445,
        0.9253692626953125
      ],
      "plane_d": -2881.90869140625,
      "bbox_min": [
        -3403.0,
        -5064.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4964.44189453125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9179146885871887,
        -0.15040530264377594,
        0.36716586351394653
      ],
      "plane_d": -4245.66162109375,
      "bbox_min": [
        -3380.0,
        -5010.8232421875,
        1061.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4964.44189453125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1061.70703125,
      "bbox_min": [
        -3374.0,
        -5010.8232421875,
        1061.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5003.50048828125,
        1061.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284767508506775,
        0.0,
        0.3713906705379486
      ],
      "plane_d": -3533.30224609375,
      "bbox_min": [
        -3380.0,
        -5006.26708984375,
        1063.57373046875
      ],
      "bbox_max": [
        -3379.60009765625,
        -5003.50048828125,
        1064.7069091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162277638912201,
        0.0,
        -0.9486833214759827
      ],
      "plane_d": -59.728759765625,
      "bbox_min": [
        -3380.0,
        -5006.26708984375,
        1063.57373046875
      ],
      "bbox_max": [
        -3379.60009765625,
        -5003.50048828125,
        1063.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3378.0,
      "bbox_min": [
        -3403.0,
        -5064.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4966.8828125,
        1079.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3162277638912201,
        0.0,
        -0.9486833214759827
      ],
      "plane_d": -59.728759765625,
      "bbox_min": [
        -3379.60009765625,
        -5017.3349609375,
        1063.0404052734375
      ],
      "bbox_max": [
        -3378.0,
        -5006.26708984375,
        1063.57373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.745356023311615,
        -0.596284806728363,
        0.2981424033641815
      ],
      "plane_d": -5838.1376953125,
      "bbox_min": [
        -3380.0,
        -5036.333984375,
        1063.0404052734375
      ],
      "bbox_max": [
        -3378.0,
        -5034.00048828125,
        1068.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3052144944667816,
        -0.2616124451160431,
        -0.9156435132026672
      ],
      "plane_d": -1374.605712890625,
      "bbox_min": [
        -3380.0,
        -5036.333984375,
        1063.0404052734375
      ],
      "bbox_max": [
        -3378.0,
        -5034.00048828125,
        1063.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3380.0,
      "bbox_min": [
        -3381.0,
        -5064.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5061.00048828125,
        1063.706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5061.00048828125,
      "bbox_min": [
        -3381.0,
        -5064.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5061.00048828125,
        1063.706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3381.0,
      "bbox_min": [
        -3381.0,
        -5064.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3381.0,
        -5061.00048828125,
        1061.206787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3381.0,
      "bbox_min": [
        -3403.0,
        -5064.00048828125,
        1061.2066650390625
      ],
      "bbox_max": [
        -3380.0,
        -5056.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5061.00048828125,
      "bbox_min": [
        -3381.0,
        -5064.00048828125,
        1061.206787109375
      ],
      "bbox_max": [
        -3380.0,
        -5061.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3380.0,
      "bbox_min": [
        -3381.0,
        -5064.00048828125,
        1063.7066650390625
      ],
      "bbox_max": [
        -3380.0,
        -5061.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.800000011920929,
        0.6000000238418579
      ],
      "plane_d": 3402.17626953125,
      "bbox_min": [
        -3381.0,
        -5062.50048828125,
        1077.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5061.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 3394.999755859375,
      "bbox_min": [
        -3403.0,
        -5064.00048828125,
        1063.70703125
      ],
      "bbox_max": [
        -3395.0,
        -5056.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9238730072975159,
        0.38269925117492676
      ],
      "plane_d": 4260.1953125,
      "bbox_min": [
        -3403.0,
        -5064.00048828125,
        1063.70703125
      ],
      "bbox_max": [
        -3395.0,
        -5056.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.38268932700157166,
        -0.9238771796226501
      ],
      "plane_d": 2920.673583984375,
      "bbox_min": [
        -3403.0,
        -5064.00048828125,
        1063.70703125
      ],
      "bbox_max": [
        -3395.0,
        -5056.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8932863473892212,
        -0.44948819279670715
      ],
      "plane_d": 4997.72607421875,
      "bbox_min": [
        -3403.0,
        -5059.17236328125,
        1066.0501708984375
      ],
      "bbox_max": [
        -3395.0,
        -5056.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5056.00048828125,
      "bbox_min": [
        -3403.0,
        -5059.17236328125,
        1070.70703125
      ],
      "bbox_max": [
        -3395.0,
        -5056.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.38268932700157166,
        0.9238771796226501
      ],
      "plane_d": 938.5745239257812,
      "bbox_min": [
        -3403.0,
        -5059.17236328125,
        1079.3638916015625
      ],
      "bbox_max": [
        -3395.0,
        -5058.34375,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1064.70703125,
      "bbox_min": [
        -3378.0,
        -5054.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5003.50048828125,
        1079.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3162277638912201,
        0.0,
        -0.9486833214759827
      ],
      "plane_d": -59.728759765625,
      "bbox_min": [
        -3378.0,
        -5054.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5007.56884765625,
        1064.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2747211456298828,
        -0.9615240097045898
      ],
      "plane_d": -362.089599609375,
      "bbox_min": [
        -3378.0,
        -5054.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5034.00048828125,
        1064.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3052144944667816,
        -0.2616124451160431,
        -0.9156435132026672
      ],
      "plane_d": -1374.605712890625,
      "bbox_min": [
        -3378.0,
        -5041.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5034.00048828125,
        1064.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7347689270973206,
        -0.6298019289970398,
        0.25192078948020935
      ],
      "plane_d": -5921.912109375,
      "bbox_min": [
        -3378.0,
        -5041.00048828125,
        1063.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5035.93359375,
        1064.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": -5075.50244140625,
      "bbox_min": [
        -3374.0,
        -5041.00048828125,
        1063.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5040.6005859375,
        1064.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5053.00048828125,
      "bbox_min": [
        -3373.0,
        -5054.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5053.00048828125,
        1064.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5054.00048828125,
      "bbox_min": [
        -3373.0,
        -5054.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5053.00048828125,
        1064.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3373.0,
      "bbox_min": [
        -3373.0,
        -5054.00048828125,
        1061.70703125
      ],
      "bbox_max": [
        -3373.0,
        -5053.00048828125,
        1064.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5053.00048828125,
      "bbox_min": [
        -3373.0,
        -5054.00048828125,
        1060.3736572265625
      ],
      "bbox_max": [
        -3370.0,
        -5053.00048828125,
        1061.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5054.00048828125,
      "bbox_min": [
        -3373.0,
        -5054.00048828125,
        1060.3736572265625
      ],
      "bbox_max": [
        -3370.0,
        -5053.00048828125,
        1061.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3373.0,
      "bbox_min": [
        -3373.0,
        -5054.00048828125,
        1061.3736572265625
      ],
      "bbox_max": [
        -3373.0,
        -5053.00048828125,
        1061.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5053.00048828125,
      "bbox_min": [
        -3373.0,
        -5054.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5053.00048828125,
        1061.3736572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5054.00048828125,
      "bbox_min": [
        -3373.0,
        -5054.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5053.00048828125,
        1061.3736572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3373.0,
      "bbox_min": [
        -3373.0,
        -5054.00048828125,
        1056.70703125
      ],
      "bbox_max": [
        -3373.0,
        -5053.00048828125,
        1061.3736572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5053.00048828125,
      "bbox_min": [
        -3378.0,
        -5054.00048828125,
        1064.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5034.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5054.00048828125,
      "bbox_min": [
        -3373.0,
        -5054.00048828125,
        1064.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5053.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3373.0,
      "bbox_min": [
        -3373.0,
        -5054.00048828125,
        1064.70703125
      ],
      "bbox_max": [
        -3371.5,
        -5053.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        0.0,
        0.6000000238418579
      ],
      "plane_d": -3345.024169921875,
      "bbox_min": [
        -3373.0,
        -5054.00048828125,
        1077.70703125
      ],
      "bbox_max": [
        -3371.5,
        -5053.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7347689270973206,
        -0.6298019289970398,
        0.25192078948020935
      ],
      "plane_d": -5921.912109375,
      "bbox_min": [
        -3378.0,
        -5040.6005859375,
        1064.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5034.00048828125,
        1068.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.6246950626373291,
        0.0
      ],
      "plane_d": 5782.490234375,
      "bbox_min": [
        -3378.0,
        -5039.00048828125,
        1064.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5034.00048828125,
        1068.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5039.00048828125,
      "bbox_min": [
        -3374.0,
        -5039.00048828125,
        1064.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5039.00048828125,
        1068.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162277936935425,
        0.0,
        -0.9486833810806274
      ],
      "plane_d": -43.6011962890625,
      "bbox_min": [
        -3377.0,
        -4962.00048828125,
        1078.70703125
      ],
      "bbox_max": [
        -3374.0,
        -4959.5595703125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1078.70703125,
      "bbox_min": [
        -3377.0,
        -4962.00048828125,
        1078.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162277936935425,
        0.0,
        -0.9486833810806274
      ],
      "plane_d": -43.6011962890625,
      "bbox_min": [
        -3377.0,
        -4962.00048828125,
        1078.70703125
      ],
      "bbox_max": [
        -3374.0,
        -4959.00048828125,
        1079.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3445.0,
      "bbox_min": [
        -3445.0,
        -5079.00048828125,
        1036.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1041.70703125,
      "bbox_min": [
        -3445.0,
        -5079.00048828125,
        1036.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1056.70703125
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4974.00048828125,
      "bbox_min": [
        -3400.0,
        -4994.00048828125,
        1036.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4974.00048828125,
        1041.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4994.00048828125,
      "bbox_min": [
        -3400.0,
        -4994.00048828125,
        1036.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4974.00048828125,
        1041.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3400.0,
      "bbox_min": [
        -3400.0,
        -4994.00048828125,
        1036.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4974.00048828125,
        1041.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4980.00048828125,
      "bbox_min": [
        -3380.0,
        -4994.00048828125,
        1036.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4974.00048828125,
        1041.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3380.0,
      "bbox_min": [
        -3380.0,
        -4980.00048828125,
        1036.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4974.00048828125,
        1041.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3380.0,
      "bbox_min": [
        -3380.0,
        -4994.00048828125,
        1036.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4988.00048828125,
        1041.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5079.00048828125,
      "bbox_min": [
        -3445.0,
        -5079.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 6016.7724609375,
      "bbox_min": [
        -3445.0,
        -5079.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2495131641626358,
        0.2495131641626358,
        -0.9356743097305298
      ],
      "plane_d": 3108.0986328125,
      "bbox_min": [
        -3445.0,
        -5079.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.96592116355896,
        -0.25883668661117554
      ],
      "plane_d": -4534.8603515625,
      "bbox_min": [
        -3445.0,
        -5064.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1056.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4953.50048828125,
      "bbox_min": [
        -3445.0,
        -4953.50048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4925.00048828125,
      "bbox_min": [
        -3430.0,
        -4953.50048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7766754627227783,
        -0.629901111125946,
        0.0
      ],
      "plane_d": -450.46337890625,
      "bbox_min": [
        -3430.0,
        -4953.50048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7766754627227783,
        -0.629901111125946,
        -0.0
      ],
      "plane_d": -5731.8564453125,
      "bbox_min": [
        -3430.0,
        -4953.50048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4118106961250305,
        -0.9112694263458252,
        -0.0
      ],
      "plane_d": -5885.40966796875,
      "bbox_min": [
        -3430.0,
        -4953.50048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4118106961250305,
        -0.9112694263458252,
        0.0
      ],
      "plane_d": -3085.096923828125,
      "bbox_min": [
        -3430.0,
        -4953.50048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4925.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9741045236587524,
        -0.2260982245206833,
        0.0
      ],
      "plane_d": 2221.20068359375,
      "bbox_min": [
        -3430.0,
        -4953.50048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4940.70068359375,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9741045236587524,
        -0.2260982245206833,
        -0.0
      ],
      "plane_d": -4402.7099609375,
      "bbox_min": [
        -3412.0,
        -4953.50048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4940.70068359375,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4948.00048828125,
      "bbox_min": [
        -3412.0,
        -4948.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3392.0,
        -4945.00048828125,
        1056.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4945.00048828125,
      "bbox_min": [
        -3412.0,
        -4948.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3392.0,
        -4945.00048828125,
        1056.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3408.0,
      "bbox_min": [
        -3412.0,
        -4948.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3392.0,
        -4945.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3412.0,
      "bbox_min": [
        -3412.0,
        -4948.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3412.0,
        -4945.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3392.0,
      "bbox_min": [
        -3396.0,
        -4948.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3392.0,
        -4945.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3396.0,
      "bbox_min": [
        -3396.0,
        -4948.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3396.0,
        -4945.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.96592116355896,
        0.25883668661117554
      ],
      "plane_d": -5093.44287109375,
      "bbox_min": [
        -3417.0,
        -5064.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4974.00048828125,
        1056.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.25881466269493103,
        0.965927004814148
      ],
      "plane_d": -2305.8046875,
      "bbox_min": [
        -3417.0,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4974.00048828125,
        1051.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.25881466269493103,
        0.965927004814148
      ],
      "plane_d": 274.0601806640625,
      "bbox_min": [
        -3417.0,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4974.00048828125,
        1051.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.7071186304092407,
        0.7070950269699097
      ],
      "plane_d": -4270.5244140625,
      "bbox_min": [
        -3417.0,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4974.00048828125,
        1051.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071186304092407,
        -0.7070950269699097
      ],
      "plane_d": -2778.034423828125,
      "bbox_min": [
        -3417.0,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4974.00048828125,
        1051.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 3403.78271484375,
      "bbox_min": [
        -3417.0,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4974.00048828125,
        1051.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2639448642730713,
        -0.9316486716270447,
        0.24972748756408691
      ],
      "plane_d": -5810.974609375,
      "bbox_min": [
        -3417.0,
        -4993.75,
        1041.70703125
      ],
      "bbox_max": [
        -3403.782958984375,
        -4974.2509765625,
        1051.456298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2638828158378601,
        0.9316651225090027,
        0.2497318983078003
      ],
      "plane_d": 3475.98876953125,
      "bbox_min": [
        -3417.0,
        -4992.443359375,
        1041.70703125
      ],
      "bbox_max": [
        -3403.782958984375,
        -4974.2509765625,
        1051.456298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2639195919036865,
        -0.2496478259563446,
        0.9316772222518921
      ],
      "plane_d": -3122.187744140625,
      "bbox_min": [
        -3417.0,
        -4992.443359375,
        1041.70703125
      ],
      "bbox_max": [
        -3403.782958984375,
        -4975.5576171875,
        1051.456298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2639194428920746,
        0.2496478408575058,
        0.9316772818565369
      ],
      "plane_d": -633.6974487304688,
      "bbox_min": [
        -3417.0,
        -4992.443359375,
        1041.70703125
      ],
      "bbox_max": [
        -3403.782958984375,
        -4975.5576171875,
        1051.456298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2639124095439911,
        -0.6820229887962341,
        0.6820520758628845
      ],
      "plane_d": -5017.0849609375,
      "bbox_min": [
        -3417.0,
        -4992.443359375,
        1041.70703125
      ],
      "bbox_max": [
        -3403.782958984375,
        -4975.5576171875,
        1050.150146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26388686895370483,
        0.6820278763771057,
        0.6820569634437561
      ],
      "plane_d": 1781.427001953125,
      "bbox_min": [
        -3417.0,
        -4991.81884765625,
        1041.70703125
      ],
      "bbox_max": [
        -3403.782958984375,
        -4975.5576171875,
        1050.150146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5802797079086304,
        0.5758677124977112,
        0.5758923292160034
      ],
      "plane_d": 284.9619140625,
      "bbox_min": [
        -3417.0,
        -4991.81884765625,
        1041.70703125
      ],
      "bbox_max": [
        -3410.599365234375,
        -4976.18212890625,
        1049.525390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5802817940711975,
        -0.7866702079772949,
        0.21076788008213043
      ],
      "plane_d": -6125.58251953125,
      "bbox_min": [
        -3417.0,
        -4991.81884765625,
        1041.70703125
      ],
      "bbox_max": [
        -3410.599365234375,
        -4976.18212890625,
        1049.525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5803149342536926,
        0.7866474390029907,
        0.21076177060604095
      ],
      "plane_d": 1715.7271728515625,
      "bbox_min": [
        -3417.0,
        -4990.771484375,
        1041.70703125
      ],
      "bbox_max": [
        -3410.599365234375,
        -4976.18212890625,
        1049.525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5802695751190186,
        -0.5759293437004089,
        0.5758407711982727
      ],
      "plane_d": -5455.5068359375,
      "bbox_min": [
        -3417.0,
        -4990.771484375,
        1041.70703125
      ],
      "bbox_max": [
        -3410.599365234375,
        -4979.66162109375,
        1049.525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5802793502807617,
        -0.21078705787658691,
        0.7866668701171875
      ],
      "plane_d": -3855.2900390625,
      "bbox_min": [
        -3417.0,
        -4988.33935546875,
        1041.70703125
      ],
      "bbox_max": [
        -3410.599365234375,
        -4979.66162109375,
        1049.525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5802768468856812,
        0.21078751981258392,
        0.786668598651886
      ],
      "plane_d": -1754.1553955078125,
      "bbox_min": [
        -3417.0,
        -4988.33935546875,
        1041.70703125
      ],
      "bbox_max": [
        -3410.599365234375,
        -4979.66162109375,
        1049.525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9279272556304932,
        -0.0964779257774353,
        0.3600599765777588
      ],
      "plane_d": -4026.650634765625,
      "bbox_min": [
        -3417.0,
        -4988.33935546875,
        1041.70703125
      ],
      "bbox_max": [
        -3415.31640625,
        -4979.66162109375,
        1046.0458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9279270768165588,
        0.0964779183268547,
        0.3600599765777588
      ],
      "plane_d": -3064.957763671875,
      "bbox_min": [
        -3417.0,
        -4988.33935546875,
        1041.70703125
      ],
      "bbox_max": [
        -3415.31640625,
        -4979.66162109375,
        1046.0458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9279235005378723,
        -0.3600585460662842,
        0.09651809185743332
      ],
      "plane_d": -5065.7900390625,
      "bbox_min": [
        -3417.0,
        -4988.33935546875,
        1041.70703125
      ],
      "bbox_max": [
        -3415.31640625,
        -4979.66162109375,
        1045.464599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9279235005378723,
        0.3600585460662842,
        0.09651809185743332
      ],
      "plane_d": -1476.7261962890625,
      "bbox_min": [
        -3417.0,
        -4987.7578125,
        1041.70703125
      ],
      "bbox_max": [
        -3415.31640625,
        -4979.66162109375,
        1045.464599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9279245138168335,
        -0.2636071741580963,
        0.26356667280197144
      ],
      "plane_d": -4759.095703125,
      "bbox_min": [
        -3417.0,
        -4987.7578125,
        1041.70703125
      ],
      "bbox_max": [
        -3415.31640625,
        -4980.2431640625,
        1045.464599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9279245138168335,
        0.2636072039604187,
        0.26356664299964905
      ],
      "plane_d": -2131.458740234375,
      "bbox_min": [
        -3417.0,
        -4984.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3415.31640625,
        -4980.2431640625,
        1045.464599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3380.0,
      "bbox_min": [
        -3403.782958984375,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4974.00048828125,
        1051.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3378.0,
      "bbox_min": [
        -3380.0,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4974.00048828125,
        1051.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1046.70703125,
      "bbox_min": [
        -3380.0,
        -4988.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4980.00048828125,
        1046.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4980.00048828125,
      "bbox_min": [
        -3380.0,
        -4988.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4980.00048828125,
        1046.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4988.00048828125,
      "bbox_min": [
        -3380.0,
        -4988.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3378.0,
        -4988.00048828125,
        1046.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06392721831798553,
        -0.9639453887939453,
        -0.25830724835395813
      ],
      "plane_d": -4308.23193359375,
      "bbox_min": [
        -3403.782958984375,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4974.00048828125,
        1051.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.06382796168327332,
        -0.9639514684677124,
        0.25830888748168945
      ],
      "plane_d": -5300.0712890625,
      "bbox_min": [
        -3403.782958984375,
        -4994.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4975.34033203125,
        1051.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.06390432268381119,
        0.2582957148551941,
        0.963949978351593
      ],
      "plane_d": 56.278228759765625,
      "bbox_min": [
        -3403.782958984375,
        -4992.66064453125,
        1046.5816650390625
      ],
      "bbox_max": [
        -3400.0,
        -4975.34033203125,
        1051.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.06389012187719345,
        -0.2582959532737732,
        0.9639508128166199
      ],
      "plane_d": -2518.367431640625,
      "bbox_min": [
        -3403.782958984375,
        -4992.66064453125,
        1046.5816650390625
      ],
      "bbox_max": [
        -3400.0,
        -4975.34033203125,
        1051.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.06391678750514984,
        -0.7056729793548584,
        0.7056488394737244
      ],
      "plane_d": -4479.11083984375,
      "bbox_min": [
        -3403.782958984375,
        -4992.66064453125,
        1046.5816650390625
      ],
      "bbox_max": [
        -3400.0,
        -4975.34033203125,
        1050.3673095703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.06391678750514984,
        -0.7056726813316345,
        -0.7056491374969482
      ],
      "plane_d": -2555.03662109375,
      "bbox_min": [
        -3403.782958984375,
        -4979.1259765625,
        1046.5816650390625
      ],
      "bbox_max": [
        -3400.0,
        -4975.34033203125,
        1050.3673095703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5064.00048828125,
      "bbox_min": [
        -3381.0,
        -5064.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5053.00048828125,
        1056.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3380.0,
      "bbox_min": [
        -3381.0,
        -5064.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5053.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3381.0,
      "bbox_min": [
        -3381.0,
        -5064.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5061.00048828125,
        1056.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 5061.00048828125,
      "bbox_min": [
        -3381.0,
        -5061.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3380.0,
        -5061.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5053.00048828125,
      "bbox_min": [
        -3373.0,
        -5054.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5053.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5054.00048828125,
      "bbox_min": [
        -3373.0,
        -5054.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3370.0,
        -5053.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3373.0,
      "bbox_min": [
        -3373.0,
        -5054.00048828125,
        1041.70703125
      ],
      "bbox_max": [
        -3373.0,
        -5053.00048828125,
        1056.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1001.70703125,
      "bbox_min": [
        -3425.0,
        -4994.00048828125,
        1001.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4974.00048828125,
        1036.70703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4994.00048828125,
      "bbox_min": [
        -3425.0,
        -4994.00048828125,
        1001.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4974.00048828125,
        1036.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3380.0,
      "bbox_min": [
        -3417.0,
        -4994.00048828125,
        1001.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4974.00048828125,
        1036.70703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4980.00048828125,
      "bbox_min": [
        -3378.0,
        -4988.00048828125,
        1031.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4980.00048828125,
        1036.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4988.00048828125,
      "bbox_min": [
        -3378.0,
        -4988.00048828125,
        1031.70703125
      ],
      "bbox_max": [
        -3370.0,
        -4988.00048828125,
        1036.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4974.00048828125,
      "bbox_min": [
        -3417.0,
        -4994.00048828125,
        1001.70703125
      ],
      "bbox_max": [
        -3380.0,
        -4974.00048828125,
        1036.70703125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3400.0,
      "bbox_min": [
        -3400.0,
        -4994.00048828125,
        1016.70703125
      ],
      "bbox_max": [
        -3400.0,
        -4974.00048828125,
        1036.70703125
      ],
      "face_count": 2
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}